//#<

/*
import List from "src/dataTypes/lists/List";
import StringList from "src/dataTypes/strings/StringList";
import NumberList from "src/dataTypes/numeric/NumberList";
import ListOperators from "src/operators/lists/ListOperators";
import StringOperators from "src/operators/strings/StringOperators";
import NumberListOperators from "src/operators/numeric/numberList/NumberListOperators";
import TableOperators from "src/operators/lists/TableOperators";
import NumberListGenerators from "src/operators/numeric/numberList/NumberListGenerators";
import Network from "src/dataTypes/structures/networks/Network";
import Node from "src/dataTypes/structures/elements/Node";
import Relation from "src/dataTypes/structures/elements/Relation";
import ColorOperators from "src/operators/graphic/ColorOperators";
*/


/**
 * @classdesc  MetaExtractor
 *
 * @namespace
 * @category basics
 */
function MetaExtractor() {}
export default MetaExtractor;


MetaExtractor.STRING_SHORT_LENGTH = 255;
MetaExtractor.STRING_MEDIUM_LENGTH = 255*10;
MetaExtractor.REGEX_EMAIL = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/;//lower case
MetaExtractor.REGEX_SSN = /^(\d{3}-\d{2}-\d{4}|\d{9})$/;
MetaExtractor.REGEX_CPF = /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{9}-\d{2}|\d{11})$/;
MetaExtractor.REGEX_URL = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;//kind of too broad (exemple: "http://moebio")
MetaExtractor.REGEX_URL_FILE = /(http(s?):)([\/|.|\w|\s|-])*\.(?:csv|txt)/;
MetaExtractor.REGEX_URL_IMAGE = /(http(s?):)([\/|.|\w|\s|-])*\.(?:jpg|gif|png|jpeg)/;
// rewrite date regex to include months as strings and 'i' flag(uncase sensitive).
MetaExtractor.REGEX_DATE =  /((0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\\d\\d)|((0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\\d\\d)|((19|20)\\d\\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01]))|((19|20)\\d\\d[- /.](0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012]))|(0[1-9]|[0-9]|[12][0-9]|3[01])[- /.](?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)[- /.]\d{4}/i;
/*
MetaExtractor.REGEX_DATE = new RegExp('((0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\\d\\d)|'+
                            '((0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\\d\\d)|'+
                            '((19|20)\\d\\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01]))|'+
							'((19|20)\\d\\d[- /.](0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012]))|'+
							'([0-2][0-9]|(3)[0-1])[- /.](?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)[- /.]\d{4}');
*/
MetaExtractor.REGEX_PERSON_NAME = /^(([A-Za-z]+[\-\']?)*([A-Za-z]+)?\s)+([A-Za-z]+[\-\']?)*([A-Za-z]+)?$/;//from https://stackoverflow.com/questions/3073850/javascript-regex-test-peoples-name

//clean texts in this list:
MetaExtractor.BIG_CITIES_NAMES = ["aba","abbottabad","abeokuta","abidjan","abu dhabi","abuja","acapulco","accra","ad damman","adana","addis ababa","adelaide","aden","agadir","agra","aguascalientes","ahmedabad","ahvaz","ajmer","akola","akron","al hillah","al hudaydah","al hufuf","al ladhiqiyah","albany","albuquerque","aleppo","alexandria","algiers","aligarh","allahabad","allentown","almaty","amman","amravati","amritsar","amsterdam","an najaf","andijon","ankang","ankara","annaba","anqing","ansan","anshan","anshun","antalya","antananarivo","antwerpen","anyang","aracaju","arak","arequipa","as sulaymaniyah","asansol","ashgabat","asmara","astrakhan","asuncion","asunción","at taif","athens","atlanta","auckland","aurangabad","austin","az zarqa","bacolod","baghdad","bahawalpur","bakersfield","baku","baltimore","bamako","banda aceh","bandar lampung","bandjarmasin","bandung","bangalore","banghazi","bangkok","bangui","bannu","baoding","baoji","baoshan","baotou","barcelona","bareilly","bari","barnaul","barquisimeto","barranquilla","basel","basra","baton rouge","beihai","beijing","beira","beirut","bekasi","belem","belgaum","belgrade","bello","belo horizonte","belém","bengbu","benin city","benoni","benxi","berlin","bhavnagar","bhilai","bhiwandi","bhopal","bhubaneshwar","bien hoa","bikaner","bilaspur","bilbao","binjai","birmingham","bishkek","biên hòa","blantyre","blida","bogor","bogota","bonn","bordeaux","boston","bouake","bouaké","bradford","braga","brasilia","brasília","brazzaville","bremen","bridgeport","brighton","brisbane","bristol","bronx","brooklyn","brussels","bucaramanga","bucharest","budapest","buenos aires","buffalo","bukittinggi","bulawayo","bur said","bursa","busan","butterworth","bytom","cagayan de oro","cairo","calgary","cali","callao","campinas","campo grande","can tho","cancun","cancún","cangzhou","canoas","cape coral","cape town","caracas","cardiff","cartagena","casablanca","catania","cebu","chandigarh","chandrapur","changchun","changde","changhua","changping","changsha","changwon","changzhi","changzhou","charleston","charlotte","chelyabinsk","chengdu","chennai","cheongju","chicago","chiclayo","chifeng","chihuahua","chisinau","chittagong","chișinău","chongjin","chongqing","cilacap","cincinnati","ciudad guayana","ciudad juarez","ciudad juárez","cleveland","cochabamba","coimbatore","cologne","colorado springs","columbia","columbus","conakry","concepcion","concepción","concord","constantine","cordoba","cotonou","cucuta","cuernavaca","cuiaba","cuiabá","culiacan","culiacán","curitiba","cuttack","córdoba","cúcuta","da nang","daegu","daejeon","dahuk","dakar","dalian","dallas","damascus","dandong","daqing","dar es salaam","datong","davangere","davao","dayton","dehra dun","delhi","denpasar","denver","detroit","dhaka","dhanbad","diyarbakir","diyarbakır","djibouti","dnipro","doha","donetsk","dongguan","dortmund","douala","dresden","dubai","dublin","duisburg","durban","dushanbe","dusseldorf","düsseldorf","edinburgh","edmonton","el giza","el mansura","el paso","enugu","eskisehir","eskişehir","essen","faisalabad","fargona","faridabad","fez","florence","florianopolis","florianópolis","fort worth","fortaleza","foshan","frankfurt","freetown","fresno","fukuoka","fushun","fuxin","fuyang","fuzhou","ganzhou","gaziantep","gdansk","gdańsk","general santos","geneva","genoa","george town","ghaziabad","glasgow","gliwice","goiania","goiânia","gold coast","gorakhpur","goteborg","goyang","grand rapids","guadalajara","guangzhou","guatemala","guayaquil","guilin","guiyang","gujranwala","guntur","guwahati","gwalior","gwangju","göteborg","hachioji","hachiōji","haifa","haikou","haiphong","hamadan","hamamatsu","hamburg","hamhung","hamilton","handan","hangzhou","hannover","hanoi","haora","harare","harbin","hartford","havana","hechi","hefei","hegang","helsinki","hengyang","hermosillo","heze","hims","hiroshima","hisar","ho chi minh city","hohhot","hong kong","honolulu","houston","hsinchu","huaibei","huainan","huaiyin","huambo","huangshi","hubli","hue","hungnam","huzhou","hyderabad","ibadan","ikare","ilorin","incheon","indianapolis","indore","ipoh","irbid","irbil","irkutsk","isfahan","islamabad","ismailia","ismaïlia","istanbul","izhevsk","izmir","jabalpur","jaboatao","jacksonville","jaipur","jakarta","jalalabad","jammu","jamshedpur","jeddah","jeonju","jerusalem","jhansi","jiamusi","jian","jiangmen","jianmen","jiaozuo","jiaxing","jilin","jinan","jincheng","jinhua","jining","jinxi","jinzhou","jiujiang","jixi","joao pessoa","jodhpur","johannesburg","johor bahru","joinville","jos","joão pessoa","jullundur","jundiai","jundiaí","kabul","kaduna","kagoshima","kaifeng","kalyan","kampala","kananga","kanazawa","kandahar","kano","kanpur","kansas city","kaohsiung","karachi","karaj","karbala","kashgar","kathmandu","katowice","kawasaki","kayseri","kazan","kelang","kenitra","kerman","kermanshah","khabarovsk","kharkiv","khartoum","khulna","kiev","kigali","kikwit","kingston","kinshasa","kirkuk","kisangani","kitakyushu","kitakyūshū","knoxville","kobe","kobenhavn","kochi","kolhapur","kolkata","konya","kota","kota baharu","kota kinabalu","kozhikode","krakow","kraków","krasnodar","krasnoyarsk","kryvyy rih","kuala lumpur","kuching","kumamoto","kumasi","kunming","kuwait","kyoto","københavn","kōbe","la paz","la plata","lagos","lahore","langfang","lanzhou","las vegas","leeds","leipzig","leon","leshan","león","lianyungang","liaoyang","liaoyuan","libreville","liege","lille","lilongwe","lima","linfen","lingyuan","linxia","linyi","lipetsk","lisbon","liuzhou","liverpool","liège","lodz","lome","lomé","london","londrina","los angeles","louisville","luan","luanda","lubumbashi","lucknow","ludhiana","luoyang","lupanshui","lusaka","luxor","luzhou","lvov","lyon","maanshan","macau","maceio","maceió","madrid","madurai","maiduguri","makhachkala","makkah","malacca","malaga","malang","malegaon","managua","manama","manaus","manchester","mandalay","mangalore","manhattan","manila","mannheim","maoming","maputo","mar del plata","maracaibo","maracay","marrakesh","marseille","mashhad","matamoros","matola","matsuyama","mbuji-mayi","mcallen","medan","medellin","medellín","medina","meerut","meknes","melbourne","memphis","mendoza","merida","mexicali","mexico city","miami","mianyang","milan","milwaukee","minneapolis","minsk","mission viejo","mogadishu","mombasa","monrovia","monterrey","montevideo","montreal","montréal","moradabad","morelia","moscow","moshi","mosul","mudangiang","multan","mumbai","munich","muscat","mykolayiv","mysore","málaga","mérida","naga","nagano","nagoya","nagpur","naha","nairobi","namangan","nampo","nanchang","nanchong","nanded","nanjing","nanning","nantong","nanyang","naples","nashville","nasik","natal","naypyidaw","ndjamena","neijiang","nellore","new haven","new orleans","new york","newcastle","nezahualcoyotl","niamey","nice","niigata","ningbo","niteroi","niterói","nizhny novgorod","nottingham","nouakchott","nova iguacu","nova iguaçu","novo hamburgo","novokuznetsk","novosibirsk","nurnberg","nürnberg","oaxaca","odessa","ogbomosho","ogden","okayama","oklahoma city","olinda","omaha","omdurman","omsk","oran","orenburg","orlando","osaka","oslo","otsu","ottawa","ouagadougou","oyo","padang","palembang","palermo","palu","panama city","paris","patna","pekanbaru","penza","pereira","perm","perth","peshawar","philadelphia","phnom penh","phoenix","pietermaritzburg","pingdingshan","pingtung","pingxiang","pittsburgh","pointe-noire","pontianak","port elizabeth","port harcourt","port louis","port-au-prince","portland","porto","porto alegre","poznan","poznań","prague","pretoria","providence","provo","puch'on","puebla","puerto la cruz","pune","puyang","pyongyang","qingdao","qingyuan","qinhuangdao","qiqihar","qom","quanzhou","quebec","queens","queretaro","querétaro","quetta","quetzaltenango","quezon city","qui nhon","quito","québec","rabat","raipur","rajkot","rajshahi","raleigh","ranchi","rangoon","rasht","raurkela","rawalpindi","recife","ribeirao preto","ribeirão preto","richmond","riga","rio de janeiro","riverside","riyadh","rizhao","rochester","rome","rosario","rostov","rotterdam","rouen","ryazan","saarbrucken","saarbrücken","sacramento","saidu","saint louis","salem","salerno","salt lake city","salta","saltillo","salvador","samara","samarinda","samarqand","samsun","san antonio","san diego","san francisco","san jose","san josé","san luis potosi","san luis potosí","san pedro sula","san salvador","sanaa","sangli","santa cruz","santiago","santiago de cuba","santo andre","santo andré","santo domingo","santos","sao jose dos campos","sao jose dos pinhais","sao luis","sao paulo","sapporo","sarajevo","sarasota","saratov","sargodha","seattle","semarang","sendai","seoul","seville","shanghai","shangqiu","shangrao","shantou","shaoguan","shaoxing","sharjah","shashi","sheffield","shenyeng","shenzhen","shihezi","shijianzhuang","shimoga","shiraz","shiyan","shizuoka","sholapur","shuozhou","shuyang","siliguri","singapore","siping","sofia","sohag","sokoto","soledad","songnam","sorocaba","southend-on-sea","springfield","srinagar","st. petersburg","stockholm","stuttgart","suez","suining","surabaya","surakarta","surat","suwon","suzhou","sydney","são josé dos campos","são josé dos pinhais","são luís","são paulo","tabriz","tabuk","taian","taichung","tainan","taipei","taiyuan","taizhou","taizz","tampa","tampico","tangier","tangshan","tarsus","tashkent","tbilisi","tegucigalpa","tehran","tel aviv-yafo","teresina","the hague","thessaloniki","thiruvananthapuram","tianjin","tianshui","tijuana","tirana","tiruchirappalli","tirunelveli","tiruppur","tlaxcala","tokyo","toluca","tolyatti","tomsk","tongliao","tongling","toronto","torreon","torreón","toulouse","trablous","trabzon","tripoli","trujillo","tucson","tucuman","tucumán","tulsa","tunis","turin","tyumen","uberlandia","uberlândia","ufa","ujjain","ujungpandang","ulaanbaatar","ulsan","ulyanovsk","urmia","urumqi","utrecht","utsunomiya","uyo","vadodara","valencia","valparaiso","valparaíso","vancouver","varanasi","veracruz","vereeniging","vienna","vientiane","vijayawada","vila velha","vilnius","vina del mar","vinh","virginia beach","vishakhapatnam","vitoria","vitória","viña del mar","vladivostok","volgograd","voronezh","wanzhou","warangal","warri","warsaw","washington","weifang","weihai","wenzhou","wiesbaden","winnipeg","wroclaw","wrocław","wuhan","wuhu","wuppertal","wuxi","xiamen","xian","xiangfan","xiangtai","xiangtan","xiantao","xianyang","xingyi","xining","xinxiang","xinyang","xinyi","xinyu","xuanzhou","xuzhou","yancheng","yangjiang","yangquan","yangzhou","yantai","yaounde","yaroslavl","yekaterinburg","yerevan","yibin","yichang","yichun","yinchuan","yingkow","yiyang","yogyakarta","yokohama","yongzhou","yuci","yueyang","yulin","zagreb","zahedan","zamboanga","zaozhuang","zaporizhzhya","zaragoza","zaria","zhangjiakou","zhangzhou","zhanjiang","zhanyi","zhaotang","zhengzhou","zhenjiang","zhongli","zhucheng","zhuhai","zhuozhou","zhuzhou","zibo","zigong","zunyi","zurich","zürich","ürümqi","i̇zmir","łódź","ōsaka","ōtsu"];

//reduce number
MetaExtractor.BRAZIL_CITIES_NAMES = ["uruguaiana","cabo de santo agostinho","sao gabriel","sao borja","santo angelo","santa rosa","salvador","vila velha","santa cruz do sul","muriae","londrina","porto uniao","itanhaem","foz do iguacu","novo hamburgo","fernandopolis","guarapuava","guajara-miram","arcoverde","mossoro","maringa","estancia","crateus","ponta pora","penapolis","cruzeiro do sul","erechim","itapipoca","bacabal","cascavel","curitiba","jaboatao","ijui","apucarana","formosa","xapeco","carazinho","campo murao","brasilia","assis","paragominas","caceres","bento goncalves","santo andre","bage","concordia","camaqua","jaragua do sul","aracatuba","olinda","recife","natal","presidente prudente","parnaiba","crato","santana do livramento","corumba","campo grande","itaituba","rio branco","pelotas","manaus","cachoeira do sul","santa maria","joinville","ji-parana","arapongas","dourados","cacador","passo fundo","porto alegre","rio grande","tupa","ponta grossa","caxias do sul","sorocaba","rio negro","canoas","sobral","teofilo otoni","caxias","codo","paulo afonso","cuiaba","tubarao","vacaria","criciuma","sete lagoas","itauna","tucurui","varzea grande","formiga","santa ines","divinopolis","pirapora","lavras","curvelo","paracatu","uberlandia","araxa","iguatu","itumbiara","trindade","goiania","ituiutaba","uberaba","araguari","anapolis","pocos de caldas","sao joao del rei","aracaju","pouso alegre","ariquemes","avare","barretos","batatais","bauru","botucatu","catalao","timbauba","passos","manacapuru","vilhena","belo horizonte","carpina","serrinha","arapiraca","telemaco borba","barra mansa","alagoinhas","maceio","irece","volta redonda","garanhuns","rio largo","feira de santana","paranagua","juazeiro do norte","jatai","rondonopolis","sao jose dos pinhais","joao pessoa","goiana","vitoria da conquista","barreiras","jequie","janauba","guanambi","registro","ilheus","itabuna","caico","valenca","caruaru","campina grande","fortaleza","itapetinga","patos","pindamonhangaba","itapeva","itapetininga","itu","picos","campinas","catanduva","timon","teresina","canela","governador valadares","linhares","blumenau","sao jose de ribamar","sao mateus","sao luis","porto seguro","ipatinga","nova lima","nova vicosa","montes claros","caratinga","uba","castanhal","conselheiro lafaiete","juiz de fora","cachoeiro de itapemirim","barbacena","florianopolis","itajai","belem","palmas","braganca","vitoria","parintins","campos","petrolina","juazeiro","rio de janeiro","jaboticabal","lajes","araguaina","maraba","sao jose dos campos","gurupi","macae","niteroi","marilia","franca","guaratingueta","santarem","ourinhos","jau","tatui","taubate","santos","sao joao da boa vista","barra do garcas","sao jose do rio preto","jundiai","coari","ribeirao preto","abaetetuba","tefe","imperatriz","altamira","boa vista","sao paulo","macapa","itacoatiara","porto santana","balsas","porto velho","brusque","americana","limeira","piracicaba","pirassununga","rio claro","sao carlos","tres lagoas","andradina","braganca paulista","nova friburgo","cabo frio","nova iguacu","petropolis"];
MetaExtractor.US_CITIES_NAMES = ["renton","seattle","yakima","federal way","lakewood","longview","sammamish","wenatchee","kennewick","auburn","kent","kirkland","redmond","olympia","bremerton","tacoma","walla walla","richland","spokane valley","bellevue","marysville","bellingham","spokane","pasco","vancouver","mount vernon","shoreline","everett","burien","winchester","richmond","virginia beach","chesapeake","charlottesville","norfolk","suffolk","harrisonburg","fredericksburg","blacksburg","portsmouth","newport news","leesburg","staunton","hampton","roanoke","williamsburg","alexandria","lynchburg","wilmington","dover","washington","beloit","fond du lac","janesville","kenosha","la crosse","oshkosh","sheboygan","appleton","west allis","west bend","waukesha","milwaukee","madison","wausau","racine","green bay","eau claire","wheeling","beckley","huntington","charleston","morgantown","parkersburg","weirton","honolulu","bradenton","lakeland","ocala","daytona beach","pinellas park","winter haven","pembroke pines","port saint lucie","clearwater","panama city","sarasota","orlando","sebring","saint cloud","bonita springs","port orange","tallahassee","sanford","largo","miami","north port","west palm beach","palm coast","boynton beach","miramar","doral","palm bay","miami beach","delray beach","hollywood","miami gardens","saint petersburg","fort myers","sunrise","coral gables","lauderhill","tamarac","jupiter","pompano beach","cape coral","zephyrhills","pensacola","wellington","deltona","tampa","saint augustine","plantation","apopka","coconut creek","deerfield beach","palm beach gardens","titusville","gainesville","hialeah","davie","margate","fort lauderdale","kissimmee","homestead","boca raton","north miami","weston","coral springs","jacksonville","melbourne","cheyenne","casper","manchester","nashua","bayonne","hoboken","plainfield","paterson","west new york","perth amboy","elizabeth","vineland","jersey city","trenton","union city","newark","camden","new brunswick","east orange","passaic","atlantic city","clifton","farmington","rio rancho","los lunas","santa fe","albuquerque","las cruces","frisco","waco","sherman","pasadena","irving","arlington","pharr","fort worth","new braunfels","lubbock","corpus christi","lewisville","desoto","wichita falls","lake jackson","mcallen","georgetown","san angelo","san marcos","mission","texarkana","carrollton","mckinney","laredo","euless","pflugerville","allen","sugar land","port arthur","amarillo","plano","mesquite","baytown","north richland hills","eagle pass","garland","rowlett","beaumont","el paso","denton","harlingen","grapevine","edinburg","odessa","round rock","dallas","tyler","midland","bryan","austin","texas city","cedar park","missouri city","conroe","flower mound","abilene","temple","mansfield","league city","richardson","houston","college station","grand prairie","victoria","killeen","brownsville","pearland","san antonio","houma","monroe","shreveport","slidell","new orleans","lafayette","hammond","kenner","mandeville","baton rouge","lake charles","bossier city","new bern","burlington","hickory","charlotte","raleigh","rocky mount","concord","goldsboro","chapel hill","cary","fayetteville","gastonia","winston-salem","durham","high point","huntersville","greenville","asheville","greensboro","apex","bismarck","grand forks","fargo","grand island","lincoln","omaha","memphis","chattanooga","bartlett","hendersonville","clarksville","morristown","jackson","knoxville","johnson city","cleveland","nashville","bristol","collierville","kingsport","murfreesboro","franklin","syracuse","saratoga springs","utica","new rochelle","middletown","schenectady","buffalo","queens","glens falls","white plains","watertown","kingston","elmira","albany","rochester","hempstead","new york","bronx","poughkeepsie","ithaca","yonkers","brooklyn","binghamton","manhattan","staten island","state college","harrisburg","altoona","pottstown","york","lebanon","chambersburg","williamsport","erie","philadelphia","hazleton","lancaster","johnstown","bloomsburg","scranton","hanover","reading","monessen","pittsburgh","allentown","east stroudsburg","bethlehem","pomona","upland","redding","el monte","burbank","irvine","rocklin","salinas","apple valley","lodi","vallejo","indio","hesperia","cathedral city","buena park","downey","bakersfield","san bernardino","encinitas","palm desert","whittier","chula vista","cupertino","fullerton","lompoc","victorville","anaheim","delano","lynwood","temecula","corona","walnut creek","fresno","milpitas","national city","arcadia","fairfield","porterville","mission viejo","pleasanton","vista","carson","tracy","gardena","palo alto","chino hills","santa maria","santa barbara","orange","lake elsinore","sunnyvale","watsonville","monterey park","san rafael","costa mesa","roseville","livermore","turlock","pittsburg","gilroy","huntington park","rosemead","yucaipa","norwalk","ontario","torrance","antioch","elk grove","el centro","south gate","glendora","laguna niguel","sacramento","seaside","folsom","fontana","daly city","riverside","el cajon","merced","murrieta","rialto","woodland","santa rosa","palmdale","west covina","long beach","santee","madera","brentwood","aliso viejo","santa cruz","vacaville","stockton","simi valley","alameda","fremont","santa monica","camarillo","fountain valley","rancho cordova","south san francisco","paramount","compton","petaluma","yorba linda","menifee","hawthorne","redwood city","eastvale","alhambra","escondido","dublin","santa clarita","manteca","san francisco","tustin","santa ana","moreno valley","san clemente","hemet","hanford","glendale","west sacramento","berkeley","san luis obispo","napa","baldwin park","davis","la habra","rancho cucamonga","newport beach","citrus heights","oakland","chico","diamond bar","garden grove","bellflower","san mateo","oceanside","san diego","san jose","carlsbad","redlands","clovis","mountain view","oxnard","redondo beach","pico rivera","thousand oaks","colton","cerritos","chino","placentia","westminster","visalia","san leandro","poway","los angeles","modesto","santa clara","perris","inglewood","san ramon","arroyo grande","huntington beach","tulare","lake forest","highland","hayward","yuba city","novato","la mesa","montebello","henderson","carson city","las vegas","sparks","north las vegas","reno","parker","denver","thornton","loveland","centennial","colorado springs","grand junction","broomfield","arvada","aurora","castle rock","pueblo","longmont","fort collins","commerce city","boulder","greeley","anchorage","fairbanks","hoover","gadsden","tuscaloosa","montgomery","mobile","dothan","decatur","anniston","birmingham","huntsville","daphne","florence","springdale","jonesboro","rogers","north little rock","hot springs","little rock","conway","fort smith","cicero","evanston","arlington heights","chicago","dekalb","elgin","berwyn","naperville","peoria","joliet","normal","orland park","carbondale","springfield","skokie","oak park","bolingbrook","tinley park","waukegan","schaumburg","oak lawn","champaign","kankakee","wheaton","alton","hoffman estates","rockford","mount prospect","round lake beach","bloomington","des plaines","palatine","atlanta","johns creek","valdosta","alpharetta","marietta","augusta","rome","brookhaven","savannah","stonecrest","hinesville","warner robins","dalton","sandy springs","athens","smyrna","cartersville","brunswick","columbus","roswell","terre haute","south bend","fort wayne","gary","elkhart","carmel","kokomo","fishers","noblesville","anderson","evansville","greenwood","muncie","indianapolis","michigan city","davenport","ankeny","dubuque","iowa city","waterloo","council bluffs","des moines","cedar rapids","sioux city","ames","west des moines","broken arrow","midwest city","edmond","lawton","oklahoma city","tulsa","moore","norman","scottsdale","flagstaff","buckeye","avondale","tucson","gilbert","prescott valley","mesa","sierra vista","casa grande","yuma","chandler","surprise","lake havasu city","goodyear","phoenix","tempe","nampa","pocatello","boise","twin falls","caldwell","coeur d'alene","lewiston","idaho falls","meridian","waterbury","new britain","city of milford (balance)","bridgeport","meriden","danbury","west haven","hartford","new haven","norwich","stamford","bangor","portland","salisbury","rockville","hagerstown","frederick","bowie","gaithersburg","baltimore","quincy","chicopee","waltham","medford","boston","haverhill","newton","pittsfield","brockton","cambridge","somerville","methuen","lawrence","revere","new bedford","worcester","peabody","lowell","leominster","malden","lynn","fall river","taunton","toledo","hamilton","akron","parma","youngstown","kettering","canton","cincinnati","elyria","lorain","lima","dayton","orem","west valley city","west jordan","salt lake city","layton","ogden","saint george","millcreek","taylorsville","lehi","logan","provo","south jordan","columbia","saint peters","joplin","saint louis","florissant","cape girardeau","jefferson city","independence","saint joseph","kansas city","blue springs","lees summit","saint charles","o'fallon","maple grove","minnetonka","edina","mankato","coon rapids","burnsville","eagan","minneapolis","eden prairie","plymouth","blaine","brooklyn park","lakeville","woodbury","duluth","saint paul","holland","novi","south lyon","bay city","kentwood","wyoming","rochester hills","muskegon","westland","saint clair shores","grand rapids","ann arbor","kalamazoo","saginaw","livonia","pontiac","battle creek","lansing","sterling heights","port huron","flint","dearborn","troy","warren","taylor","detroit","southfield","benton harbor","dearborn heights","farmington hills","royal oak","providence","warwick","cranston","pawtucket","overland park","lenexa","topeka","shawnee","olathe","wichita","great falls","billings","helena","missoula","bozeman","hattiesburg","southaven","gulfport","mount pleasant","summerville","hilton head island","sumter","myrtle beach","beaufort","north charleston","spartanburg","rock hill","mauldin","bowling green","louisville","owensboro","lexington","elizabethtown","bend","grants pass","salem","tigard","beaverton","gresham","eugene","corvallis","hillsboro","sioux falls","rapid city"];

MetaExtractor.LABELS_FOR_CITY_LIST =  ["city","cities","cidade","cidades"];

//TBD:add ISO2
MetaExtractor.COUNTRIES_NAMES = ["af","ax","al","dz","as","ad","ao","ai","aq","ag","ar","am","aw","au","at","az","bs","bh","bd","bb","by","be","bz","bj","bm","bt","bo","bq","ba","bw","bv","br","io","bn","bg","bf","bi","kh","cm","ca","cv","ky","cf","td","cl","cn","cx","cc","co","km","cg","cd","ck","cr","ci","hr","cu","cw","cy","cz","dk","dj","dm","do","ec","eg","sv","gq","er","ee","et","fk","fo","fj","fi","fr","gf","pf","tf","ga","gm","ge","de","gh","gi","gr","gl","gd","gp","gu","gt","gg","gn","gw","gy","ht","hm","va","hn","hk","hu","is","in","id","ir","iq","ie","im","il","it","jm","jp","je","jo","kz","ke","ki","kp","kr","kw","kg","la","lv","lb","ls","lr","ly","li","lt","lu","mo","mk","mg","mw","my","mv","ml","mt","mh","mq","mr","mu","yt","mx","fm","md","mc","mn","me","ms","ma","mz","mm","na","nr","np","nl","nc","nz","ni","ne","ng","nu","nf","mp","no","om","pk","pw","ps","pa","pg","py","pe","ph","pn","pl","pt","pr","qa","re","ro","ru","rw","bl","sh","kn","lc","mf","pm","vc","ws","sm","st","sa","sn","rs","sc","sl","sg","sx","sk","si","sb","so","za","gs","ss","es","lk","sd","sr","sj","sz","se","ch","sy","tw","tj","tz","th","tl","tg","tk","to","tt","tn","tr","tm","tc","tv","ug","ua","ae","gb","us","um","uy","uz","vu","ve","vn","vg","vi","wf","eh","ye","zm","zw", "afg","ago","arg","arm","aus","aut","aze","bdi","bel","ben","bfa","bgd","bgr","bhs","blr","blz","bol","bra","brb","btn","bwa","caf","can","che","chl","chn","civ","cmr","cog","col","com","cpv","cri","cub","cze","deu","dnk","dom","dza","ecu","egy","eri","esp","est","eth","fin","fji","fra","gab","gbr","geo","gha","gin","gmb","gnb","gnq","grc","gtm","guy","hnd","hrv","hti","hun","idn","ind","irl","irn","isl","isr","ita","jam","jpn","kaz","ken","kgz","khm","kor","lao","lbn","lbr","lka","lso","ltu","lux","lva","mar","mda","mdg","mdv","mex","mli","mlt","mmr","mng","moz","mrt","mus","mwi","mys","nam","ner","nga","nic","nld","nor","npl","nzl","omn","pak","pan","per","phl","png","pol","prt","pry","qat","rou","rus","rwa","sdn","sen","sgp","sle","slv","srb","sur","svk","svn","swe","swz","tcd","tgo","tha","tjk","tun","tur","tza","uga","ukr","ury","usa","uzb","ven","vnm","yem","zaf","zmb","zwe","alb","are","bhr","brn","cod","cyp","hkg","irq","jor","kwt","lby","mkd","mne","pse","sau","slb","tkm","ton","vct","vut","wsm","bih","tls","abw","atg","grd","kir","syc","fsm","afghanistan","albania","algeria","american samoa","andaman islands","andorra","angola","anguilla","antarctica","antigua","aral sea","argentina","aruba","australia","austria","azores","bahamas","bahrain","bangladesh","barbados","barbuda","0","belgium","belize","benin","bhutan","black sea","bolivia","bonaire","yugoslavia","botswana","brazil","brunei","bulgaria","burkina faso","burundi","california","cambodia","cameroon","canada","canary islands","cape verde","caspian sea","cayman islands","central african republic","chad","chagos archipelago","chile","china","colombia","comoros","congo","zaire","cook islands","costa rica","cuba","curacao","cyprus","czechoslovakia","denmark","djibouti","dominica","dominican republic","ecuador","egypt","el salvador","equatorial guinea","ethiopia","falkland islands","fiji","finland","france","french guiana","french polynesia","gabon","gambia","gaza strip","germany","ghana","great lakes","greece","greenland","grenada","guadeloupe","guatemala","guinea","guinea-bissau","guyana","haiti","hawaii","honduras","hungary","iceland","india","indonesia","iran","iraq","ireland","irian jaya","isle of man","isle of wight","israel","italy","ivory coast","jamaica","japan","jordan","kenya","kiribati","kuwait","lacul greaca","lake albert","lake fjerritslev","lake kariba","lake malawi","lake pasvikelv","lake tanganyika","lake titicaca","lake victoria","laos","lebanon","lesotho","liberia","libya","liechtenstein","luxembourg","yogoslavia","madagascar","madeira islands","malawi","malaysia","maldives","mali","malta","marshall islands","martinique","maug island","mauritania","mauritius","mexico","federated states of","","monaco","mongolia","montserrat","morocco","mozambique","myanmar","namibia","nauru","nepal","netherlands","neutral zone","nevis","new caledonia","new zealand","nicaragua","niger","nigeria","democratic people's republic of","northern mariana islands","norway","oman","pakistan","panama","papua new guinea","paracel islands","paraguay","peru","philippines","pitcairn islands","poland","portugal","puerto rico","qatar","romania","rwanda","saint eustatius","saint kitts","saint lucia","saint vincent","saint-barthelemy","saint-martin","san marino","sao tome and principe","sardinia","saudi arabia","senegal","seychelles","sicily","sierra leone","sin cowe island","solomon islands","somalia","sonsorol island","south africa","republic of","south sandwich islands","spain","spratly island","sri lanka","sudan","suriname","swaziland","sweden","switzerland","syria","tanzania","thailand","tobago","togo","tokelau","tonga","trinidad","tunisia","turkey","turks and caicos","tuvalu","uganda","uk","united arab emirates","uruguay","usa","ussr","vanuatu","venezuela","vietnam","virgin islands","vislinskiy zaliv","wales","west bank","western sahara","yemen","zambia","zimbabwe","aland islands","antigua and barbuda","armenia","azerbaijan","belarus","bosnia and herzegovina","bouvet island","british indian ocean territory","brunei darussalam","bermuda","united states","christmas island","cocos (keeling) islands","democratic republic of the congo","croatia","czech republic","eritrea","estonia","falkland islands (malvinas)","faroe islands","french southern and antarctic lands","georgia","gibraltar","guam","holy see (vatican city)","hong kong","iran (islamic republic of)","cote d'ivoire","kazakhstan","kyrgyzstan","lao people's democratic republic","latvia","libyan arab jamahiriya","lithuania","the former yugoslav republic of macedonia","macau","republic of moldova","mayotte","micronesia","montenegro","burma","netherlands antilles","niue","korea","north korea","norfolk island","palau","palestine","reunion","saint helena","saint kitts and nevis","saint vincent and the grenadines","saint barthelemy","saint pierre and miquelon","saint martin","serbia","singapore","slovakia","slovenia","south korea","svalbard","syrian arab republic","taiwan","tajikistan","united republic of tanzania","timor-leste","trinidad and tobago","turkmenistan","turks and caicos islands","united kingdom","ukraine","untied arab emirates","uzbekistan","russia","viet nam"];
MetaExtractor.US_STATES_NAMES = ["alabama","al","alaska","ak","arizona","az","arkansas","ar","california","ca","colorado","co","connecticut","ct","delaware","de","florida","fl","georgia","ga","hawaii","hi","idaho","id","illinois","il","indiana","in","iowa","ia","kansas","ks","kentucky","ky","louisiana","la","maine","me","maryland","md","massachusetts","ma","michigan","mi","minnesota","mn","mississippi","ms","missouri","mo","montana","mt","nebraska","ne","nevada","nv","new hampshire","nh","new jersey","nj","new mexico","nm","new york","ny","north carolina","nc","north dakota","nd","ohio","oh","oklahoma","ok","oregon","or","pennsylvania","pa","rhode island","ri","south carolina","sc","south dakota","sd","tennessee","tn","texas","tx","utah","ut","vermont","vt","virginia","va","washington","wa","west virginia","wv","wisconsin","wi","wyoming","wy"];

MetaExtractor.DEOMGRAPHIC_NAMES = ["gender","age","marital status","married","sex"];

MetaExtractor.TOLERANCE_ALL_DIFFERENT = 0.98;
MetaExtractor.MIN_SCORE_SPECIFICATION = 0.3;


MetaExtractor.ICONS_CITY = {
	name:"city",
	url_image:"http://moebio.com/data/icons_specification/city.png"
};
MetaExtractor.ICONS_WORLD = {
	name:"world",
	url_image:"http://moebio.com/data/icons_specification/earth.png"
};
MetaExtractor.ICONS_US = {
	name:"US",
	url_image:"http://moebio.com/data/icons_specification/us.png"
};
MetaExtractor.ICONS_Brazil = {
	name:"Brazil",
	url_image:"http://moebio.com/data/icons_specification/br.png"
};
MetaExtractor.ICONS_PERSON = {
	name:"person",
	url_image:"http://moebio.com/data/icons_specification/person.png"
};
MetaExtractor.ICONS_LINK = {
	name:"link",
	url_image:"http://moebio.com/data/icons_specification/link.png"
};
MetaExtractor.ICONS_EMAIL = {
	name:"email",
	url_image:"http://moebio.com/data/icons_specification/email.png"
};
MetaExtractor.ICONS_MONEY = {
	name:"money",
	url_image:"http://moebio.com/data/icons_specification/money.png"
};
MetaExtractor.ICONS_IMAGE = {
	name:"image",
	url_image:"http://moebio.com/data/icons_specification/picture.png"
};
MetaExtractor.ICONS_TIME = {
	name:"time",
	url_image:"http://moebio.com/data/icons_specification/time.png"
};
MetaExtractor.ICONS_TEXT = {
	name:"text",
	url_image:"http://moebio.com/data/icons_specification/text.png"
};


MetaExtractor._relationsMemory = {};





/**
 * TO BE MOVED TO FRAMEWORK
 * @param  {mo.List} l0 categories
 * @param  {mo.NumberList} l1 numbers
 * @return {Number} to what extent a category is helpful to predict a number
 */
MetaExtractor._varianceInDistributionFunction = function(l0,l1){
	if(!l0.metaExtractor.information.isCategorical) return 0;
	//initial version only takes into acccount averages
	//next version will use averages, count (for weighing) and sd
	var aggregation = mo.ListOperators.aggregateList(l0, l1, "enlist");

	var lists = aggregation[1];

	var mean = l0.getAverage();
	var weight = 0;
	var sv = 0;

	for(var i=0; i<lists.length; i++){
		weight += lists[i].length;
		sv += lists[i].length+Math.abs(mo.NumberList.fromArray(lists[i]).getAverage()-mean);
	}
	sv/=(weight*lists.length*mean);

	var balance = Math.pow(1-l0.metaExtractor.information.proportionDifferentElements, 0.2);
	//var sv = aggregation[1].getStandardDeviation()/l0.getAverage();
	var w = balance*0.5*sv;
	console.log("[mE] balance, sv, w, lists[0]", balance, sv, w);
	//if(l0.metaExtractor.information.informationScore<0.5) return 0;
	return w;
};


/**
 * TO BE MOVED TO FRAMEWORK
 * @param  {[type]} l0 [description]
 * @param  {[type]} l1 [description]
 * @return {[type]}    [description]
 */
MetaExtractor._functionalDependencyFunction = function(l0,l1){
	if(l0 == null || l1 == null) return;
	if(l0.length!=l1.length) return 0;
	if(mo.ListOperators.getListEntropy(l0) === 0 || mo.ListOperators.getListEntropy(l1) === 0) return -1;

	let tupleTable = new mo.Table();
	tupleTable.push(l0);
	tupleTable.push(l1);
	let t = tupleTable.getListsSortedByMultipleLists([0,1], false);
	let X = t[0];
	let A = t[1];
	let c = X[0];
	let countC = 0;
	let c1 = [ X[0], A[0] ];
	let countC1 = 0;
	let sum = 0;
	let maxCountC = 0;
	for( let i=0; i<= X.length; i++){
		let xValue = X[i];
		let yValue = A[i];

		if(xValue == c) {
			countC++;
			if( xValue == c1[0] && yValue == c1[1]){
				countC1++;
			} else {
				if(maxCountC < countC1) {
					maxCountC = countC1;
				}
				c1 = [ xValue, yValue ];
				countC1 = 1;
			}
			if(maxCountC < countC1) {
					maxCountC = countC1;
			}
		} else {
			sum += (maxCountC / countC)*(countC/X.length);
			c = xValue;
			countC = 1;
			maxCountC = 1;
			c1 = [ xValue, yValue ];
			countC1 = 1;
		}
	}
	//console.log("[mE] functionalDependency, sum:", sum);
	return Math.min(1,sum);
};

MetaExtractor._relationFunctionObjects = function(){
	if(this._arrayRelationFunctionObjects) return this._arrayRelationFunctionObjects;

	var correlation = {
		propertyName:'correlation',
		name:"Pearson Correlation",
		domain:"NumberList",
		range:"NumberList",
		type:"Number",
		directional:false,
		threshold:0.6,
		decimals:4,
		function:mo.NumberListOperators.pearsonProductMomentCorrelation,
		color:'blue'
	};

	var jaccard = {
		propertyName:'jaccard',
		name:"Jaccard",
		domain:"StringList",
		range:"StringList",
		type:"Number",
		directional:false,
		threshold:0.3,
		decimals:4,
		function:mo.ListOperators.jaccardIndex,
		color:'green'
	};

	var infoGain = { // take care of unique element lists, and all different lists / for efficiency sake, and for discarding trivial cases
		propertyName:'infoGain',
		name:"Information Gain",
		domain:"StringList",
		range:"StringList",
		type:"Number",
		directional:true,
		threshold:0.6,
		decimals:2,
		function:function(l0, l1){
			if(l0.metaExtractor.information.uniqueValue || l0.metaExtractor.information.allDifferent || l1.metaExtractor.information.uniqueValue || l1.metaExtractor.information.allDifferent) return 0;
			var ig = mo.ListOperators.getInformationGain(l0, l1, true);
			//MetaExtractor._relationsMemory[l0.metaExtractor.id+"_"+l1.metaExtractor.id+"_ig"] = ig;
			return ig;
		},
		color:'orange'
	};

	var infoGainBalanced = { // take care of unique element lists, and all different lists / for efficiency sake, and for discarding trivial cases
		propertyName:'infoGainBalanced',
		name:"Information Gain Balanced",
		domain:"List",
		range:"List",
		type:"Number",
		directional:true,
		threshold:0.63,
		decimals:2,
		function:function(l0, l1){
			if(l0.metaExtractor.information.uniqueValue || l0.metaExtractor.information.allDifferent || l1.metaExtractor.information.uniqueValue || l1.metaExtractor.information.allDifferent) return 0;
			var ig = mo.ListOperators.getInformationGain(l0, l1, true)
			var balance = Math.pow(1-l0.metaExtractor.information.proportionDifferentElements, 0.1)*Math.pow(l1.metaExtractor.information.proportionDifferentElements, 0.1);
			//console.log("[mE] ", l0.name, l1.name, " | ig, balance, igB:", ig, balance, ig*balance);
			MetaExtractor._relationsMemory[l0.metaExtractor.id+"_"+l1.metaExtractor.id+"_ig"] = ig*balance;
			return ig*balance;
		},
		description:"identifies the extent a category predicts another category",
		color:'rgb(255,200,0)'
	};

	var functionalDependency0 = {
		propertyName:'functionalDependency0',
		name:"Functional Dependency 0",
		domain:"List",
		range:"List",
		type:"Number",
		directional:true,
		threshold:0,
		decimals:4,
		function: MetaExtractor._functionalDependencyFunction,
		color:'purple'
	};

	var functionalDependency1 = {
		propertyName:'functionalDependency1',
		name:"Functional Dependency 1",
		domain:"List",
		range:"List",
		type:"Number",
		directional:true,
		threshold:1,
		decimals:4,
		function: MetaExtractor._functionalDependencyFunction,
		color:'rgb(50,50,0)'
	};

	var infoEquivalence = {
		propertyName:'infoEquivalence',
		name:"Information Equivalence",
		domain:"List",
		range:"List",
		type:"Number",
		directional:false,
		threshold:0.7,
		decimals:3,
		function:function(l0, l1){
			return Math.min(
				MetaExtractor._relationsMemory[l0.metaExtractor.id+"_"+l1.metaExtractor.id+"_ig"],
				MetaExtractor._relationsMemory[l1.metaExtractor.id+"_"+l0.metaExtractor.id+"_ig"]
			);
		},
		color:'red'
	};

	var varianceInDistribution = {
		propertyName:'varianceInDistribution',
		name:"Variance In Distribution",
		domain:"List",
		range:"NumberList",
		type:"Number",
		directional:true,
		threshold:0.7,
		decimals:3,
		function: MetaExtractor._varianceInDistributionFunction,
		color:'rgb(0,200,255)'
	};

	var isSimilar = {
		propertyName:'isSimilar',
		name:"Is Similar",
		domain:"List",
		range:"List",
		type:"Number",
		directional:false,
		threshold:0.8,
		decimals:2,
		function:function(l0, l1){
			var mE0 = l0.metaExtractor;
			var mE1 = l1.metaExtractor;

			let nameMatch = 1 - mo.StringOperators.getLevenshteinDistance(mE0.simplifiedName, mE1.simplifiedName, true);// stringMatchCalculation( [_resourceName], [resourceName]);
            nameMatch = Math.pow(nameMatch, 2);
            let typeMatch = l0.type === l1.type? 1:0;
            let cLengthMatch = Math.abs(mE0.information.content.meanCountCharacters - mE1.information.content.meanCountCharacters);
            cLengthMatch = Math.min(2, cLengthMatch);//Tolerance of 2 character of diference <-- apply confidence intervals to better definition!
            cLengthMatch = 1 - (cLengthMatch/2);

            return (nameMatch + typeMatch + cLengthMatch) / 3;
		},
		color:'pink'
	};



	//var arrayRelationFunctionObjects = [correlation, jaccard, infoGain, infoGainBalanced, functionalDependency0, functionalDependency1, infoEquivalence, varianceInDistribution, isSimilar];
	//var arrayRelationFunctionObjects = [infoGain, infoGainBalanced, functionalDependency0, functionalDependency1, varianceInDistribution];
	//var arrayRelationFunctionObjects = [varianceInDistribution];

	//v1
	var arrayRelationFunctionObjects = [correlation, jaccard, infoGainBalanced, functionalDependency0, infoEquivalence, isSimilar];


	for(var k=0; k<arrayRelationFunctionObjects.length; k++){
		arrayRelationFunctionObjects[k].validDomains = MetaExtractor._getValidDomains(arrayRelationFunctionObjects[k].domain);
		arrayRelationFunctionObjects[k].validRanges = MetaExtractor._getValidDomains(arrayRelationFunctionObjects[k].range);
	}

	return arrayRelationFunctionObjects;
};

/*
MetaExtractor._arrayOfArraysToTable = function(datasetSample) {
	let sampleAsTable = mo.Table.fromArray(datasetSample.map(function(list){return mo.List.fromArray(list).getImproved()}));

	for (const col of sampleAsTable) {
	  const colName = col.shift();
	  col.name = colName;
	}

	return sampleAsTable;
};
*/


MetaExtractor._standardDataAppsTable = function(){
	return [
		{
			id:"Studio",
			name:"Studio template project",
			description:"Studio template project loads the dataset as a new Studio project and displays a data report.",
			instructions:"Simply connect to the data loaded by the DataLoader module.",
			short:"Sd",
			project:"#/templates/projects/standardDataApps/StudioTemplate",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/studio.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/studioBIG.png",
			tags:"studio",
			onlyOnStudio:true,
			condition_text:"no conditions",
			condition:"true",
			level:"advanced"
		},
		{
			id:"EzDash",
			name:"EzDash segmentation analysis",
			description:"EzDash segmentation analysis provides a drag and drop interface to combine, filter, analyze, and visualize datasets.",
			instructions:"Drag features from the left menu to the space on the right. Drag one feature on top of a visualization to combine. Choose the best visualization for each variable or combination.",
			project:"#/templates/projects/standardDataApps/GenericNest1",
			short:"Ds",
			layoutId:"60",
			filters:"true",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/dash.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/dashBIG.png",
			tags:"segmentation,filter,dashboard",
			type:"segmentation",
			condition_text:"no conditions",
			condition:"mE.attributes.length>0",//in the future: chek it's a tabular dataset
			level:"medium"
		},

		{
			id:"Dialogues",
			name:"Dialogue exploration",
			description:"Explore the Network of Conversations and extract and read Dialogues between any two nodes",
			instructions:"Select two nodes in the Conversations Network, read the Dialogue",
			short:"Dl",
			project:"#/templates/projects/standardDataApps/Dialogues",
			layoutId:"20",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/dialogues.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/dialoguesBIG.png",
			tags:"network,conversations,dialogues,text,time",
			type:"exploration",
			condition_text:"the Table contains from, to, timestamp and content features",
			condition:"mE.isConversations",
			level:"simple"
		},
		{
			id:"Conversations",
			name:"Conversations Panel",
			description:"See the flow of words and accounts in the Conversations Table",
			instructions:"",
			short:"CN",
			project:"#/templates/projects/standardDataApps/Conversations",
			layoutId:"20",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/conversations.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/conversationsBIG.png",
			tags:"network,conversations,dialogues,text,time",
			type:"exploration",
			condition_text:"the Table contains from, to, timestamp and content features",
			condition:"mE.isConversations",
			level:"medium"
		},


		{
			id:"GeoMap",
			name:"Geo Map cartographic analysis",
			description:"Geo Map generates a simple cartographic visualization based on geographic coordinates or city names.",
			instructions:"Select a category for associating values to colors. Select a numeric feature to define points size.",
			short:"GM",
			project:"#/templates/projects/standardDataApps/GeoMap",
			layoutId:"26",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/map.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/mapBIG.png",
			tags:"geo,map",
			type:"map",
			condition_text:"the Table contains geographic coordinates or names of cities",
			condition:"mE.containsGeoCoordinates || mE.containsCities",
			level:"simple"
		},
		{
			id:"Documenta",
			name:"Documenta words cloud",
			description:"Documenta Words Cloud visualizes the relations between words and different category values in an interactive Word Cloud format.",
			instructions:"Select a category for grouping texts. Rollover words for identification of associated category values. Explore the other visual options.",
			short:"Dc",
			project:"#/templates/projects/standardDataApps/DocumentaForTable",
			layoutId:"26",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/documenta.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/documentaBIG.png",
			tags:"words,description,text",
			type:"exploration",
			condition_text:"the Table contains a column with descriptions",
			condition:"mE.specifications.includes('description') || mE.specifications.includes('unique description')",
			level:"simple"
		},
		{
			id:"Ideodrome",
			name:"Ideodrome texts exploration",
			description:"Ideodrome displays text linked by common words.  It allows for serendipitous text exploration.",
			instructions:"Zoom in and out for reading texts at different resolutions. When zoomed in, the texts have heatmaps that indicate each word frequency in the corpus. Click on a word to access all texts that contain it.",
			short:"Id",
			project:"#/templates/projects/standardDataApps/Ideodrome",
			layoutId:"30",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/ideodrome.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/ideodromeBIG.png",
			tags:"words,description,text,images",
			type:"exploration",
			condition_text:"the Table contains a column with descriptions",
			condition:"mE.specifications.includes('description') || mE.specifications.includes('unique description')",
			level:"simple"
		},
		{
			id:"Overview",
			name:"Overview of dataset",
			description:"Overview of Dataset provides statistical and other information about data features and properties.  It provides report, spreadsheet, or graphical views.",
			instructions:"You can choose to see the dataset or a table report that analyzes all its features. VariableViewer option visualizes the general structure of the data and the distribution of values in each feature.",
			short:"Ov",
			project:"#/templates/projects/standardDataApps/Overview",
			layoutId:"20",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/overview.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/overviewBIG.png",
			tags:"table",
			type:"exploration",
			condition_text:"no conditions",
			condition:"true",//in the future: adapt for other formats
			level:"simple"
		},
		{
			id:"TreeMap",
			name:"TreeMap",
			description:"TreeMap generates a hierarchy of categorical features. It allows nesting of categories and mapping size and color to selected metrics.",
			instructions:"Select the levels you want to visualize, starting with the top level of the hierarchy. Choose a numeric feature for determining the size of each internal box, and another numeric feature for a color scale.",
			short:"Tm",
			project:"#/templates/projects/standardDataApps/Treemap",
			layoutId:"13",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/treemap.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/treemapBIG.png",
			tags:"tree",
			type:"exploration",
			condition_text:"the Table contains at least 3 categories",
			condition:"mE.attributes.getPropertyValues('information.isCategorical').countElement(true)>=3",
			level:"medium"
		},
		{
			id:"TableExplorer",
			name:"Overview table explorer",
			description:"Explore automatically creates a dashboard with selected views for features and their combinations.  Features can also be filtered and prioritized.",
			instructions:"Simply select one or multiple features to focus the analysis on them. If nothing is selected there is one visualization per feature.",
			short:"Tx",
			project:"#/templates/projects/standardDataApps/TableExplorer",
			layoutId:"20",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/tableExplorer.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/tableExplorerBIG.png",
			tags:"table,dashboard",
			type:"exploration",
			condition_text:"no conditions",
			condition:"mE.attributes.length>2",//in the future: chek it's a tabular dataset
			level:"medium"
		},
		{
			id:"Combine",
			name:"Combine features combination",
			description:"Combine allows for easy selection and comparison of table features. It is ideal for combining categories and numbers.",
			instructions:"Select features for X, Y, color and size. Click or zoom on bottom and lateral bars, or in the center. When numbers are categorical (multiple values repeat), optionally visualize them as such.",
			project:"#/templates/projects/standardDataApps/Combine",
			short:"Cm",
			layoutId:"30",
			filters:"true",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/combine.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/combineBIG.png",
			tags:"segmentation,filter",
			type:"exploration",
			condition_text:"Table with at least one numeric feature",
			condition:"mE.attributes.length>3 && mE.attributes.getPropertyValues('type').countElement('NumberList')>=1",//in the future: chek it's a tabular dataset
			level:"medium"
		},
		{
			id:"Dimensions",
			name:"Dimensions",
			description:"Dimensions finds regions of elements that are similar and calculates clusters.  It uses dimension reduction analysis (PCA, TSNE, UMAP, network, k-means), in 2 and 3 dimensions.",
			instructions:"Select dimension reduction analysis method. Select 2D or 3D. Color by category or by calculated clusters. Each point is a row in the Table (a datapoint) and they appear close to each other when they share similar values.",
			short:"Dm",
			project:"#/templates/projects/standardDataApps/Dimensions",
			layoutId:"30",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/dimensions.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/dimensionsBIG.png",
			tags:"network,analysis",
			type:"analysis",
			condition_text:"no condition",
			condition:"mE.attributes.length>2",
			level:"advanced"
		},
		{
			id:"Pivot",
			name:"Pivot table view",
			description:"Pivot View generates an interactive pivot table with multiple aggregation and visualization features.",
			instructions:"Drag features into the horizontal and vertical bars, and choose a metric to analyze their combined values. Select an aggregation mode for the metric (addition, mean…).",
			short:"Pv",
			project:"#/templates/projects/standardDataApps/PivotTable",
			layoutId:"30",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/pivot.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/pivotBIG.png",
			tags:"table,analysis",
			type:"analysis",
			condition_text:"the Table contains at least 1 category",
			condition:"mE.attributes.length>2 && mE.attributes.getPropertyValues('information.isCategorical').countElement(true)>=1",
			level:"medium"
		},
		{
			id:"Predict",
			name:"Predict",
			description:"Predict creates a prediction project template in Studio.  It automatically splits data into training and test sets, and loads the EasyPredictor, multiple regression, and neural network modules.",
			instructions:"Use this project as a template for building a predictive model for your own data.",
			short:"Pd",
			project:"#/templates/projects/standardDataApps/Predict",
			thumbnail:"https://resources.lichen.com/icons_automatic_views/predict.png",
			thumbnailBIG:"https://resources.lichen.com/icons_automatic_views/predictBIG.png",
			tags:"studio,prediction",
			type:"analysis",
			onlyOnStudio:true,
			dissabled:true,
			condition_text:"enough features (>3)",
			condition:"mE.attributes.length>3",
			level:"advanced"
		}
	];
};

MetaExtractor._StandardDataAppsSuggestionsTable = function(mE) {
    var sdasForDataset = [];
    var sdas = MetaExtractor._standardDataAppsTable();
    var meetsCondition;
    var conversion;
    var urlBaseLayout = "https://studio.lichen.com/layout.html";
    var urlBase = "https://studio.lichen.com/";

    for(var i=0; i<sdas.length; i++){

		try{
        	meetsCondition = !sdas[i].dissabled && eval(sdas[i].condition);
		} catch (e){
			//console.warn('[mE] Unable to evaluate the condition on standard data product '+ sdas[i].name, '\ncondition: ',sdas[i].condition);
			continue;
		}

        if(meetsCondition){
			//console.log("[mE] mE.id", mE.id);
			//Code implemented to avoid issues when run on Server or Front enviroments.
			const isBrowser = new Function('try { return this === window } catch (error) { return false }');
			try{
				conversion = isBrowser() ? "#"+btoa("[**dataset_id**->"+mE.id+"]") : "#"+Buffer.from("[**dataset_id**->"+mE.id+"]").toString('base64');
			} catch(err){
				conversion = "#-";
			}

        	sdas[i].onlyOnStudio = !sdas[i].layoutId;
        	if(!sdas[i].onlyOnStudio){
	        	sdas[i].url = urlBaseLayout+sdas[i].project+"#@"+sdas[i].layoutId+conversion;
	        	sdas[i].urlStudio = urlBase+sdas[i].project+conversion;
	        } else {
	        	sdas[i].urlStudio = sdas[i].url = urlBase+sdas[i].project+conversion;
	        }


        	sdasForDataset.push(sdas[i]);
        }
    }

    return sdasForDataset;
};

/**
 * creates a MetaExtractor Object for a table, based on a sample
 * @param  {Object} object
 *
 * @param  {Object} complementaryInfo sample size
 * @return {Object} resourceMetaExtractor MetaExtractor Object for Table
 * tags:metaextractor,special,extract
 */
MetaExtractor.metaExtractorObject = function(object, complementaryInfo){
	if(object == null) return null;

	complementaryInfo = complementaryInfo || {_datasetName:"no name"};

	//TODO This process of type detection and parsing to Lichen object has to be improved.
	let detectedTypes = MetaExtractor._recursiveTypeOf(object);
	let detectecTypesList = detectedTypes.split('>');

	var objectIsArray = detectecTypesList[0] === 'Array';
	var objectIsArrayOfArrays = objectIsArray && detectecTypesList[1] === 'Array';

	// console.log("[mE] object is an array:", objectIsArray);
	// console.log("[mE] object is an array of arrays:", objectIsArrayOfArrays);

	if(objectIsArrayOfArrays){
		object = mo.ObjectOperators.arrayOfArraysToTable(object,true,true);
		// console.log("[mE] array of arrays converted into Table");
		// console.log("[mE] object.type:", object.type);
		//if(object.length>0) console.log("[mE] object[0].type:", object[0].type);
	} else if (objectIsArray){
		object = mo.ObjectOperators.arrayOfArraysToTable([object],true,true);
		// console.log("[mE] array converted into Table");
		// console.log("[mE] object.type:", object.type);
		//if(object.length>0) console.log("[mE] object[0].type:", object[0].type);
	}

	var type = MetaExtractor._typeOf(object);
	//console.log("[mE] detected type:", type);

	if(!["List", "NumberTable", "Table", "string"].includes(type)){
		//console.log("[mE] object is neither array, array of arrays, any type of table or a string, mE for [[]] will be returned");
		return MetaExtractor.metaExtractorObject([[]], complementaryInfo);
	}

	object.name = object.name || complementaryInfo._datasetName || 'noName';
	switch(type){
		case "List":
			return MetaExtractor.metaExtractorList(object, complementaryInfo);
		case "NumberTable":
		case "Table":
			//console.log("[mE] lists names:", object.getNames().join(","));
			return MetaExtractor.metaExtractorTable(object, complementaryInfo);
		case "string":
			return MetaExtractor.metaExtractorString(object, complementaryInfo);
	}
};


/**
 * creates a MetaExtractor Object for a List of Objects
 * @param  {mo.List} objectList list of tables
 *
 * @param {Object} complementaryInfo Object with complementary info
 * @param {Array} mEList optional list of pre-calculated metaExtractor Objects for each Object
 * @param {Number} sampleSize size of samples used for relations across Objects
 * @return {Object} MetaExtractor Object for List of Objects
 * tags:metaextractor,special,extract
 */
MetaExtractor.metaExtractorObjectList = function(objectList,complementaryInfo,mEList, sampleSize){
	if(objectList==null) return null;
	if(objectList.metExtractor!=null) return objectList.metExtractor;

	complementaryInfo = complementaryInfo || {};
	var mE = {
		objectType:"ObjectList",
		name:objectList.name,
		information:{},
		data:{},
		meaning:{},
		relations:[],
		attributes:[],
		user: complementaryInfo._user || "noUserInformation",
        organization: complementaryInfo._organization || "noOrganizationInformation",
        log:[
        	"non null object received: "+(objectList!=null),
        	"length of objectList: "+(objectList==null?0:objectList.length)
        ]
	};

	objectList.metExtractor = mE;

	for(var i=0; i<objectList.length; i++){
		mE.attributes[i] = (mEList!=null && mEList[i]!=null)?mEList[i] : MetaExtractor.metaExtractorObject(objectList[i], complementaryInfo[i] || {});
	}

	mE.log.push("attributes calculated");

	//relational info (for the time being, only for tables)
	var relationFunctionObjects = MetaExtractor._relationFunctionObjects();
	var tableList = new mo.List();
	for(i=0; i<objectList.length; i++){
		if(objectList[i]!=null && objectList[i]["isTable"]) tableList.push(objectList[i]);
	}
	MetaExtractor._buildRelationsObjectAcrossTables(tableList, mE, relationFunctionObjects, sampleSize);

	mE.log.push("relations acrooss objects calculated");

	return mE;
};


/**
 * creates a MetaExtractor Object for a table, based on a sample
 * @param  {Table} table sample Table
 *
 * @param  {Object} complementaryInfo sample size
 * @return {Object} resourceMetaExtractor MetaExtractor Object for Table
 * tags:metaextractor,special,extract
 */
MetaExtractor.metaExtractorTable = function(table, complementaryInfo){
	if(table == null || !table.isTable) return;
	if(table.metaExtractor!=null) return table.metaExtractor;

	var complementaryInfoFound = complementaryInfo!=null;


	complementaryInfo = complementaryInfo||{};

	/*
	if(complementaryInfoFound){
		complementaryInfo._resourceSource = {};
	} else {
		if(complementaryInfo._resourceSource==null){
			complementaryInfo={
				_resourceSource:{}
			};
		}
	}
	*/

	complementaryInfo._resourceSource = complementaryInfo._resourceSource||{};
	/**
	 * no SCHEMA for the time being
	 */
	//var mE = mo.SchemaInstantiator.instantiate(mo.MetaExtractorSchemaForTable);//schemaInformationObjectTable; //<------ instantiation
	var mE = {
		id: complementaryInfo._datasetId,
		objectType:"Table",
		name: table.name || 'noName',
		origin:{},
		data:{},
		information:{
			content:{}
		},
		meaning:{
			ontologyConcepts:{}
		},
		relations:new mo.List(),
		attributes:new mo.List(),
        log:[
        	"complementaryInfoFound: "+complementaryInfoFound,
        	"non null table received: "+(table!=null),
        	"length of table: "+(table==null?0:table.length)
        ]
	};

	table.metaExtractor = mE;

	var resourceInformation = {
		datasetId: complementaryInfo._datasetId || "noResourceNameInformation",
		dataSourceId: complementaryInfo._dataSourceId || "noDataSourceIdInformation",
		dataSourceName: complementaryInfo._dataSourceName || "noDataSourceNameInformation",
		datasetRowCount: complementaryInfo._rowCount || "noDatasetRowCountInformation",
		fields: complementaryInfo._fields || [],
		user: complementaryInfo._user || "noUserInformation",
		organization: complementaryInfo._organization || "noOrganizationInformation",
		name: complementaryInfo._datasetName || complementaryInfo._resourceName || table.name || "noResourceNameInformation",
		label: complementaryInfo._resourceLabel || table.label || "noResourceNameInformation",
		type: complementaryInfo._resourceType || "noResourceTypeInformation",
		source: complementaryInfo._resourceSource || "NoResourceSourceInformation",
		description: complementaryInfo._resourcedescription || "NoResourceDescriptionInformation",
		populationDatapoints: complementaryInfo._populationDataPoints,
		hasDataBaseOrigin:  complementaryInfo._resourceSource? complementaryInfo._resourceSource.database?true:false:false,
		dataBaseColumnTypesDictionary: complementaryInfo._dataBaseColumnTypesDictionary || {}
	};

	var tableInfoObject = mo.TableOperators.buildInformationObjectForTable(table);

	var anIdentifierColumnHasBeenFound = false;

	mE.containsId = false;
	mE.containsDateList = false;
	mE.containsDateListHighProportionDifferent = false;

	mE.specifications = new mo.StringList();
	mE.icons = new mo.List();

	var hasLat, hasLong;
	mE.kinds = new mo.StringList();
	mE.dataTypes = new mo.StringList();

	for(var i=0; i<table.length; i++){
		mE.attributes[i] = MetaExtractor.metaExtractorList(table[i], resourceInformation); //<------ instantiation

		if(mE.attributes[i].specification.name == "unique id" || mE.attributes[i].specification.name == "unique person name") mE.containsId=true;
		if(mE.attributes[i].specification.baseName=="date") mE.containsDateList = true;
		if(mE.attributes[i].specification.baseName=="date" && mE.attributes[i].information.proportionDifferentElements>0.8) mE.containsDateListHighProportionDifferent = true;

		if(mE.attributes[i].meaning.ontologyConcepts.DWAttributeRole === 'Identifier'){
			anIdentifierColumnHasBeenFound = true;
		}

		if(mE.attributes[i].specification.scoreConfidence>MetaExtractor.MIN_SCORE_SPECIFICATION){
			mE.specifications.push(mE.attributes[i].specification.name);
			mE.icons = mE.icons.concat(mE.attributes[i].specification.icons);

			if(mE.attributes[i].specification.name.includes("latitude geo coordinates")) hasLat=true;
			if(mE.attributes[i].specification.name.includes("longitude geo coordinates")) hasLong=true;
		}

		mE.kinds.push(mE.attributes[i].kind);
		mE.dataTypes.push(mE.attributes[i].data.datatype);
	};




	//diversities (before removing repetitions)
	mE.information.kindsDiversity =  mo.ListOperators.getListDiversity(mE.kinds);
	mE.meaning.specificationsDiversity = mo.ListOperators.getListDiversity(mE.specifications);
	mE.information.dataTypesDiversity =  mo.ListOperators.getListDiversity(mE.dataTypes);

	mE.information.kindsDiversityFactor =  0.5 + 0.5*mE.information.kindsDiversity;
	mE.information.dataTypesDiversityFactor =  0.5 + 0.5*mE.information.dataTypesDiversity;
	mE.meaning.specificationsDiversityFactor = 0.5 + 0.5*mE.meaning.specificationsDiversity;

	//remove repetitions
	mE.kinds = mE.kinds.getWithoutRepetitions();
	mE.specifications = mE.specifications.getWithoutRepetitions();
	mE.icons = mE.icons.getWithoutRepetitions();

	if(hasLat && hasLong) mE.containsGeoCoordinates = true;
	if(mE.specifications.includes("city") || mE.specifications.includes("unique city") || mE.specifications.includes("US city") || mE.specifications.includes("unique US city")) mE.containsCities = true;


	//verifies it's a Conversations Table
	//very primitive way to do it, only checking names
	var names = table.getNames();
	mE.isConversations = names.includes("to") && names.includes("from") && (names.includes("timestamp") || names.includes("dates") || names.includes("date")) && (names.includes("content") || names.includes("subject"));


	mE.specification = {
		name:""
	};



	if(table.length==2 && mE.attributes[0].information.allDifferent && mE.attributes[1].information.allDifferent){
		mE.specification.name = "Dictionary";
	} else if(mE.containsId){
		mE.specification.name = "Entity";
	} else if(mE.containsDateListHighProportionDifferent){
		mE.specification.name = "Event";
	}

	MetaExtractor._tablePropertiesExtraction(mE, tableInfoObject , resourceInformation, anIdentifierColumnHasBeenFound );


	//Update attribute Id and resource parent ID
	for(i=0; i<table.length; i++){
		// Same calculation as the Table but adding the Column Name
		const fieldInfos = resourceInformation.fields.find(f => f.name == mE.attributes[i].name);

		//attribute id origin is by default from complementary info. otherwise calculate it
		mE.attributes[i].id = fieldInfos != undefined ? fieldInfos.id : MetaExtractor._getHashFromObject(
			mE.organization +
			mE.origin.originType +
			mE.origin.originSource +
			mE.attributes[i].name +// Column name
			mE.name //include parent resource name
		);
		mE.attributes[i].parentResourceId = mE.id;
		mE.attributes[i].data.dataScore = Math.log10(mE.data.countRows + 1); //accounting for case of list with 0 elements

		//Update DataScore for the List and its total Value
		let listDIM = mE.attributes[i].DIM;
		listDIM.D = {
			total: mE.attributes[i].data.dataScore
		};
		listDIM.total = listDIM.D.total * listDIM.I.total * listDIM.M.total;
    }

	MetaExtractor._addScoreToMetaExtractor(mE, tableInfoObject);


	////////////////////automatic views <---- replaced by standard data apps, below
	///not necessarily the best place for this
	///a better option is Suggestions Tree,
	///where some suggested visualizations could be marked as automatic views
	//mE.views = [];
	//if(table.length>2) mE.views.push("dash");
	//if(mE.containsGeoCoordinates) mE.views.push("map");
	//geoTime:coordinates + dateList
	//timeline:dates
	//network:matrix table (NumberTable with multiple named columns / two entity-categories, such as names or cities)
	//treemap:hierarchies between 3 categories
	//combine:rich table
	//daisychain:dateList + category
	//text:long text
	//documenta:long texts
	//report
	////////////////////

	var relationFunctionObjects = MetaExtractor._relationFunctionObjects();// [correlation,jaccard,isSimilar,infoGain];
	MetaExtractor._buildRelationsObjectInTable(table, mE, relationFunctionObjects);

	//Apply Specific treatment to Functional Dependencies relations
	for(let i=0; i<mE.relations.length; i++){
		if( mE.relations[i].name === "Functional Dependency 0" || mE.relations[i].name === "Functional Dependency 1" ) {
			MetaExtractor._applyHeuristicsOnFunctionalDependencies( mE.relations[i] );
		}
	}

	//relational densities

	////////
	// relations.relations is problematic, should be more like: relationTypes.relations
	////////

	mE.information.relationTypes = new mo.StringList();
	mE.information.countRelations = 0;
	for(i=0; i<mE.relations.length; i++){
		if(mE.relations[i].relations.length>0) mE.information.relationTypes.push(mE.relations[i].name);
		for(j=0; j<mE.relations[i].relations.length; j++){
			mE.information.countRelations++;
		}
	}
	mE.information.relationTypes = mE.information.relationTypes.getWithoutRepetitions();
	mE.information.averageDegree = mE.information.countRelations/mE.attributes.length;
	mE.information.relationsDensity = mE.information.averageDegree/(table.length-1);

	var DEGREE_PEAK = 1.5;
	mE.information.relationsDensityMetric = 1/(1 + Math.pow( Math.sqrt(DEGREE_PEAK) - Math.sqrt(mE.information.averageDegree), 2) );

	mE.information.relationsDensityFactor = 0.9 +   0.1*mE.information.relationsDensityMetric;



	//nulls count
	mE.information.content.countNulls = 0;
	mE.information.content.countFeaturesWithNull = 0;
	mE.information.content.meanNullsPerFeature = 0;
	mE.information.content.maxNullsInFeature=0;
	for(i=0; i<table.length; i++){
		if(mE.attributes[i].information.content.countNulls){
			mE.information.content.countFeaturesWithNull++;
			mE.information.content.countNulls+=mE.attributes[i].information.content.countNulls;
			mE.information.content.maxNullsInFeature = Math.max(mE.information.content.maxNullsInFeature, mE.attributes[i].information.content.countNulls);
		}
	}
	mE.information.content.meanNullsPerFeature = mE.information.content.countNulls/table.length;

	mE.information.content.countRowsWithNulls=0;
	var nullInRow;
	for(var j=0; j<table[0].length; j++){
		nullInRow = false;
		for(i=0; i<table.length; i++){
			if(table[i][j]==null){
				nullInRow=true;
				break;
			}
		}
		if(nullInRow) mE.information.content.countRowsWithNulls++;
	}



	////////////score



	////first version relies in scoreReportObject
	////next version will calculate score based on lists' score, diversity of types in table, and relations within lists
	//var scoreReportObject = mo.TableOperators.scoreReportObject(table);
//
	///***
	//mE.information.meanAttributesScore = 0;
	//mE.meaning.meanAttributesScore = 0;
	//mE.data.meanAttributesScore = 0;
	//for(var i=0; i<mE.attributes.length; i++){
	//	mE.information.meanAttributesScore += mE.attributes[i].score.value/mE.attributes.length;
	//	mE.meaning.meanAttributesScore = 0;
	//	mE.data.meanAttributesScore = 0;
	//}
	//***/
//
//
	///** not used */ mE.information.DIMscore = scoreReportObject.properties.information;
	///** not used */mE.data.DIMscore = scoreReportObject.properties.dimensions;
	///** used temporarely */ mE.meaning.DIMscore = scoreReportObject.properties.meaning;
	///** not used */mE.dim = mE.information.DIMscore.score*mE.data.DIMscore.score*mE.meaning.DIMscore.score;


	////temporary solution for having the url of external datasets as their id
	///(loaders use the id as path)
	if(complementaryInfo && complementaryInfo.url) mE.id = complementaryInfo.url;

	//////////standard data apps
	mE.standardDataApps = MetaExtractor._StandardDataAppsSuggestionsTable(mE);



	///////////adds DIM score (in the future this addition won't happen by default)
	MetaExtractor.addsDIMtoMetaExtractor(mE);

	return mE;
};

/**
 * adds DIM property to MetaExtractor Object (currently only for Table mE) [!] this is a transformative method
 * @param  {Object} MetaExtractor Object (currently Table mE)
 * @return {Object} same MetaExtractor Object, with new property DIM
 */
MetaExtractor.addsDIMtoMetaExtractor = function(mE){
	//////////get redundancy calculation
	var redundancyObject = MetaExtractor._TableRedundancy(mE);
	mE.information.redundancy = redundancyObject;

	//////////get information score calculation
	var diversityFactor = (mE.information.kindsDiversityFactor + mE.information.dataTypesDiversityFactor) / 2;

	//infoMeanScore should be affected by the redundancy response, i.e. with a weighted average considering punning those redundant column averages with the weight
	var infoMeanScore = mo.NumberList.fromArray(mE.attributes.map(attribute => attribute.DIM.I.total)).getAverage();


	//nulls
	var nullsInTableFactor = (1 + mE.data.nAttributes*mE.data.countRows - mE.information.content.countNulls)/(1 + mE.data.nAttributes*mE.data.countRows);
	var rowsWithNullsFactor = (1 + mE.data.countRows - mE.information.content.countRowsWithNulls)/(mE.data.countRows+1);

	var nullsFactor = Math.pow(nullsInTableFactor, 1/6)*Math.pow(rowsWithNullsFactor, 1/4);

	//console.log("[mE] nullsInTableFactor, rowsWithNullsFactor, Math.pow(nullsInTableFactor, 1/6), Math.pow(rowsWithNullsFactor, 1/4), nullsFactor", nullsInTableFactor, rowsWithNullsFactor, Math.pow(nullsInTableFactor, 1/6), Math.pow(rowsWithNullsFactor, 1/4), nullsFactor);


	var informationScoreFactors = new mo.NumberList(infoMeanScore, diversityFactor, redundancyObject.redundancyCompensationFactor, nullsFactor);
	mE.information.informationScore = informationScoreFactors.getGeometricMean();// Math.pow( infoMeanScore * diversityFactor * redundancyObject.redundancyCompensationFactor * nullsFactor, 1/4);

	//Meaning score
	var meaningMeanScore = mo.NumberList.fromArray(mE.attributes.map(attribute => attribute.DIM.M.total)).getAverage();


	var meaningFactors = new mo.NumberList(meaningMeanScore, mE.meaning.specificationsDiversityFactor);
	var meaningScore = meaningFactors.getGeometricMean();

	///////////////hash
	//Instantiate the DIM object holding the DIMScore total values
	mE.DIM = {
		D:{
			total: mE.data.dataScore
		},
		I:{
			featuresInfoScoreMean:infoMeanScore,
			diversity:diversityFactor,
			redundancyFactor:redundancyObject.redundancyCompensationFactor,
			nullsScore:nullsFactor,
			total: mE.information.informationScore
		},
		M:{
			featuresMeaningScoreMean:meaningMeanScore,
			specificationsDiversity:mE.meaning.specificationsDiversityFactor,
			total:meaningScore// Math.pow( meaningMeanScore * mE.meaning.specificationsDiversityFactor, 1/2 )
		}
	};
	mE.DIM.total = mE.DIM.D.total * mE.DIM.I.total * mE.DIM.M.total;

	return mE;
};


////////// Redundancy calculation
MetaExtractor._TableRedundancy = function(mE) {
    var max = true;//temporary experiment with ways max redundancy per list is calculated

    var maxWeigthsPerFeature = {};
    for(var i=0; i<mE.attributes.length; i++){
        maxWeigthsPerFeature[mE.attributes[i].id] = 0;
    }


    for(i=0; i<mE.relations.length; i++){
        //it should be: if(mE.relations[i].measuresRedundancy
        //Infomration Equivalence = min( iG(A,B), iG(B,A) ) not yet on mE
		if(mE.relations[i].name!="Pearson Correlation" && mE.relations[i].name!="Information Equivalence") continue;
		//console.log("  [mE]", i, "mE.relations[i].name", mE.relations[i].name);
        for(j=0; j<mE.relations[i].relations.length; j++){
            let w = Math.pow(mE.relations[i].relations[j][4], 20);
            //console.log("      [mE]", j, "w", w);
            if(max){
                maxWeigthsPerFeature[mE.relations[i].relations[j][2]] = Math.max(maxWeigthsPerFeature[mE.relations[i].relations[j][2]], w);
                maxWeigthsPerFeature[mE.relations[i].relations[j][3]] = Math.max(maxWeigthsPerFeature[mE.relations[i].relations[j][3]], w);
            } else {
                maxWeigthsPerFeature[mE.relations[i].relations[j][2]] += w;
                maxWeigthsPerFeature[mE.relations[i].relations[j][3]] += w;
            }
        }
    }
    //var rW = 0; //redundancy weight
    var I = mE.attributes.length; //absolute preserved information
    var redundancies = new mo.NumberList();
    //console.log("-----");
    for(i=0; i<mE.attributes.length; i++){
        //rW+=maxWeigthsPerFeature[mE.attributes[i].id]*0.5;
        I-=maxWeigthsPerFeature[mE.attributes[i].id]*0.5;
        redundancies.push(maxWeigthsPerFeature[mE.attributes[i].id]);
        //console.log(i, maxWeigthsPerFeature[mE.attributes[i].id]);
    }
    //I/=mE.attributes.length;
    var IR = I/mE.attributes.length; //preserved information ratio
    //var I = 1 - rW/mE.attributes.length; //preserved information
    var R = (1 + Math.log(IR)/Math.log(mE.attributes.length));

    var redundancy = 1-R;
    var maxFeatureRedundancy = redundancies.getMax();
    var D = Math.log(mE.attributes.length);
    var parcialDIM = D*R;
    //var parcialDIM = Math.log(mE.attributes.length*IR);

    return {
		informationFeaturesCount:I,
		redundancy:redundancy,
        redundancyCompensationFactor:R
    };
};

////////// Functional Dependency heuristic
MetaExtractor._applyHeuristicsOnFunctionalDependencies = function( probabilisticFunctionalDependencies ) {
	//console.log('pDF function');

	//Function for threshold Calculation
	let _getThresholdIntervalForFunctionalDependencies = function(relationObject){

        let probabilities = [];//new mo.NumberList();
        let max = 0;
        for (let j = 0; j < relationObject.relations.length; j++) {
          let FD = relationObject.relations[j][4];
          probabilities.push(FD);
          max = FD > max? FD : max;
        }

        let getVariance = function(list, average) {
          var sd = 0;
          var l = list.length;
          for(var i = 0; i<l; i++) {
            sd += Math.pow(list[i] - average, 2);
          }
          return sd / list.length;
        }

        let sampleMeanList = function(_population, nSamples) {
          let sampleMeanList = [];// new mo.NumberList();
          let temporalSample;
          let populationSize = _population.length;

          //sample of average
          let averageOfaverages = 0;
          for(let i=0; i<nSamples; i++){
            let randomIndexes = Array(30).fill(0).map( v => Math.floor(Math.random() * populationSize ) );

            let sum = 0, average;
            for(let i=0; i<randomIndexes.length; i++){
              let index = randomIndexes[i];
              sum += _population[index];
            }
            average = sum/randomIndexes.length;
            sampleMeanList.push(average);
            averageOfaverages += average;
          }
          averageOfaverages = averageOfaverages/nSamples;
          return getVariance(sampleMeanList, averageOfaverages);
        }

        //let max = probabilities.getMax();
        let min = max - sampleMeanList(probabilities, 30);
        let thresholdRange =  {x:min,y:max};

        return thresholdRange;
	}

	let _networkTreatment = function (net) {

		let colorDict = {
			key: '#f20',
			attribute: '#0f2',
			forcedAttribute: '#0a2',
			forcedKey: '#a20',
			multiKey: '#84f'
		}

		let attributeAttachToOneKey = true;

		for(let i=0; i<net.nodeList.length; i++){
			let n = net.nodeList[i];

			n.keyAndAttribute = true;

			//find key
			if(n.fromRelationList.length == 0){
				n.color = colorDict.key;
				n.singleKey = true;
				n.keyAndAttribute = false;
			} else {

				for(let j=0; j<n.fromRelationList.length; j++){

					let rel = n.fromRelationList[j];
					let goRelationWeight = rel.weight;

					let n0 = rel.node0;
					let symetricRelation = n.toRelationList.getRelationsWithNode(n0)[0];
					//let symetricRelation = n0.toRelationList.getRelationsWithNode(n)[0];
					if(symetricRelation && symetricRelation.weight == goRelationWeight){
						n.color = colorDict.multiKey;
						n0.color = colorDict.multiKey;

						n.multiKey = true;
						n0.multiKey = true;

						n.symmetricFD = n.symmetricFD || [];
						n.symmetricFD.push(n0.name)

						n0.symmetricFD = n0.symmetricFD || [];
						n0.symmetricFD.push(n.name)


						n.keyAndAttribute = false;
						n0.keyAndAttribute = false;
					}
				}

			}

			if(n.toRelationList.length == 0){
				n.color = colorDict.attribute;
				n.pureAttribute = true;
				n.keyAndAttribute = false;
			}
		}

		//Restrict Attributes to Keys tentativa 3
		if(attributeAttachToOneKey){

			for(let i=0; i<net.nodeList.length; i++){

				let n = net.nodeList[i];

				//for every node select those that are pure Attributes or KeyAndAttributes
				if( (n.multiKey || n.keyAndAttribute || n.pureAttribute) && n.fromRelationList.length > 1 ){

					let choosedRelation ;
					let aSingleKeyRelation, aMultiKeyRelation;
					let maxRelations = 0;

					//loop for all the relations comming into the node
					let maxWeight = -1;
					let maxWeightCount = 0;
					let maxWeightIndex = -1;
					let singleKeyIndex = -1;
					let multiKeyIndex = -1;
					//loop for all the relations comming into the node
					for(let j=n.fromRelationList.length-1; j>=0; j--){
						let rel = n.fromRelationList[j];
						let n0 = rel.node0;
						let weight = rel.weight;

						if(weight > maxWeight) {
						    maxWeight = weight;
						    maxWeightCount = 1;
						    maxWeightIndex = j;
						} else if( weight == maxWeight) {
						    maxWeightCount++;
						}

						//store if between the source nodes are a singleKey node
						if(n0.singleKey) singleKeyIndex = j;// aSingleKeyRelation = rel.name;
						//store if between the source nodes are a multiKey node
						if (n0.multiKey) multiKeyIndex = j;// aMultiKeyRelation = rel.name;

						//if the source node is not a single key and it has more outgoing relations than the maximum registered, keep that relation
						// if((!n0.singleKey && !n0.multiKey) && n0.toRelationList.length > maxRelations){
						// 	maxRelations = n0.toRelationList.length;
						// 	choosedRelation = rel.name;
						// }
					}

					if(maxWeightCount === 1){
					    choosedRelation = n.fromRelationList[maxWeightIndex].name;
					} else if (singleKeyIndex !== -1) {
					    choosedRelation = n.fromRelationList[singleKeyIndex].name;
					} else if (multiKeyIndex !== -1) {
					    choosedRelation = n.fromRelationList[multiKeyIndex].name;
					}

					// //if the maximum number of outgoing relation form the source node is less or equal to 1
					// //and a SingleKey relation was detected give priority to the Key
					// if(maxRelations <= 1 && aSingleKeyRelation){
					// 	choosedRelation = aSingleKeyRelation;
					// }//If there was no selected Relations keep the one attached to the single key or multikey
					// else if (!choosedRelation) {
					// 	choosedRelation = aSingleKeyRelation || aMultiKeyRelation;
					// }

					//loop for all the relations comming into the node, just keep a single one
					for(let j=n.fromRelationList.length-1; j>=0; j--){

						//do remove the relation
						if(n.fromRelationList[j].name !== choosedRelation) {
							let n0 = n.fromRelationList[j].node0;

							if(!n0.symmetricFD || n0.symmetricFD.indexOf(n.name) === -1 ) net.removeRelation(n.fromRelationList[j]);
						   // else if ( ) net.removeRelation(n.fromRelationList[j]);

						}//for the one kept, update its color if its the case
						else {
							let nSource = n.fromRelationList[j].node0;
							if(nSource.keyAndAttribute){
								nSource.color = colorDict.forcedKey;
							}
						}
					}

					if(n.keyAndAttribute){
						n.color =colorDict.forcedAttribute;
					}

				}

			}
		}

	}

	let thresholdInterval = _getThresholdIntervalForFunctionalDependencies(probabilisticFunctionalDependencies);
	//First create a Network with the Functional Dependencies
	let net = new mo.Network();
	for(let i=0; i<probabilisticFunctionalDependencies.relations.length; i++){
        let FDrel = probabilisticFunctionalDependencies.relations[i];
        let nodes = [FDrel[2], FDrel[3]];

        let node0 = net.getNodeById(nodes[0]);
        if(!node0){
            node0 = new mo.Node(nodes[0]);
            net.addNode(node0);
        }
        let node1 = net.getNodeById(nodes[1]);
        if(!node1){
            node1 = new mo.Node(nodes[1]);
            net.addNode(node1);
        }

        let pFD = FDrel[4];
        if(pFD < thresholdInterval.x || pFD > thresholdInterval.y) continue;
		let relation = new mo.Relation(`${node0.id} ${node1.id}`,`${node0.name} ${node1.name}`,node0,node1,pFD,'pFD: '+pFD);
		relation.originalRelation = FDrel;
        net.addRelation(relation);
	}

	//Treat the Network to updates the relations
	_networkTreatment(net);

	let newRelations = [];
	for(let i=0; i<net.relationList.length; i++){
		let r = net.relationList[i];
		newRelations.push(r.originalRelation);
	}
	probabilisticFunctionalDependencies.relations = newRelations;
}

////////// relations
///
MetaExtractor._buildRelationsObjectInTable = function(table, mE, relationFunctionObjects){
	var randomPositions = mo.NumberListGenerators.createSortedNumberList(table[0].length).getRandomElements(200,false,Number(table.getNames().join("")));
	for(var k=0; k<relationFunctionObjects.length; k++){
		var relationObject = MetaExtractor._buildRelationObject(relationFunctionObjects[k]);
		//console.log("\n\n\n[mE]________________________________________________",relationFunctionObjects[k].name);
		mE.relations.push(relationObject);
		for(var i=0; i<table.length-1;i++){
			var sl0 = table[i].getElements(randomPositions);
			sl0.metaExtractor = table[i].metaExtractor;
			for(var j=i+1; j<table.length;j++){
				var sl1 = table[j].getElements(randomPositions);
				sl1.metaExtractor = table[j].metaExtractor;
				relationObject.relations = relationObject.relations.concat(
					MetaExtractor._calculateRelationForLists(
						table.metaExtractor.id, table.metaExtractor.id,
						sl0, sl1,
						sl0.metaExtractor.id, sl1.metaExtractor.id,
						relationFunctionObjects[k]
					)
				);
			}
		}
		relationObject.count = relationObject.relations.length;
	}
};

MetaExtractor._buildRelationsObjectAcrossTables = function(tableList, mE, relationFunctionObjects, sampleSize){
	var table0, table1;

	sampleSize = sampleSize || 100;

	//var randomPositions = NumberListGenerators.createSortedNumberList(Math.min(1000, tableList[0][0].length-1)).getSortedRandom();
	for(var k=0; k<relationFunctionObjects.length; k++){
		var relationObject = MetaExtractor._buildRelationObject(relationFunctionObjects[k]);
		mE.relations.push(relationObject);
		for(var l=0; l<tableList.length-1; l++){
			table0 = tableList[l];
			var id0 = table0.metaExtractor.id;// "table_"+l;//
			for(var m=l+1; m<tableList.length; m++){
				table1 = tableList[m];
				var randomPositions = mo.NumberListGenerators.createSortedNumberList( Math.min(table0[0].length, table1[0].length) ).getRandomElements(sampleSize, false, 0 );
				var id1 = table1.metaExtractor.id;//"table_"+m;//
				//console.log("[mE]|||| l,m,id0,id1",l,m,id0,id1);
				for(var i=0; i<table0.length;i++){
					var sl0 = table0[i].getElements(randomPositions);
					sl0.metaExtractor = table0[i].metaExtractor;
					for(var j=0; j<table1.length;j++){
						var sl1 = table1[j].getElements(randomPositions);
						sl1.metaExtractor = table1[j].metaExtractor;
						relationObject.relations = relationObject.relations.concat(
							MetaExtractor._calculateRelationForLists(
								id0, id1,
								sl0, sl1,
								sl0.metaExtractor.id, sl1.metaExtractor.id,
								relationFunctionObjects[k]
							)
						);
					}
				}
			}
		}
		relationObject.count = relationObject.relations.length;
	}
};

MetaExtractor._buildRelationObject = function(relationFunctionObject){
	return {
		name:relationFunctionObject.name,
		color:relationFunctionObject.color,
		domain:relationFunctionObject.domain,
		range:relationFunctionObject.range,
		type:relationFunctionObject.type,
		directional:relationFunctionObject.directional,
		threshold:relationFunctionObject.threshold,
		relations:[],
		count:0
	};
};

MetaExtractor._calculateRelationForLists = function(table0id, table1id, l0, l1, i, j, relationFunctionObject){
	var relations = [];

	var isValidDomain = relationFunctionObject.validDomains.includes(l0.type);
	var isValidRange = relationFunctionObject.validRanges.includes(l1.type);
	var value;

	if(isValidDomain && isValidRange){
		value = relationFunctionObject.function.call(this, l0, l1);
		// console.log("[mE] relationFunctionObject.name", relationFunctionObject.name, " | l0.name l1.name ", l0.name, l1.name, " | l0.type, l1.type ", l0.type, l1.type);
		// console.log("     [mE] <---  relationFunctionObject.type, value, relationFunctionObject.threshold", relationFunctionObject.type, value, relationFunctionObject.threshold);
		// console.log("     [mE] relationFunctionObject.type==Number", relationFunctionObject.type=="Number");
		// console.log("     [mE] Math.abs(value)>=relationFunctionObject.threshold", Math.abs(value)>=relationFunctionObject.threshold);
		if(relationFunctionObject.type=="Number" && Math.abs(value)>=relationFunctionObject.threshold){
			//console.log("     [mE] ===> relationFunctionObject.name, l0.name, l1.name, value", relationFunctionObject.name, l0.name, l1.name, value);
			// console.log("[mE]  •");
			// console.log("[mE]                 •••>>", j, i);
			if(relationFunctionObject.decimals) value = Number(value.toFixed(relationFunctionObject.decimals));
			relations.push([table0id,table1id,i,j,value]);
		}

	}

	//directional
	if(relationFunctionObject.directional){
		isValidDomain = relationFunctionObject.validDomains.includes(l1.type);
		isValidRange = relationFunctionObject.validRanges.includes(l0.type);
		if(isValidDomain && isValidRange){
			value = relationFunctionObject.function.call(this, l1, l0);
			//console.log("     [mE] <--- l0.type, l1.type, value", l0.type, l1.type, value);
			if(relationFunctionObject.type=="Number" && Math.abs(value)>=relationFunctionObject.threshold){
				//console.log("                  •••>>", j, i);
				if(relationFunctionObject.decimals) value = Number(value.toFixed(relationFunctionObject.decimals));
				relations.push([table1id,table0id,j,i,value]);
			}
		}
	}

	//console.log("•••>>•••>> relations •••>>•••>>", relations);

	return relations;
};


MetaExtractor._getValidDomains = function(domain){
	var validDomains = [domain];
	if(domain=="List") validDomains = validDomains.concat(["NumberList", "StringList"]);
	return validDomains;
}

///////////////////////////////////


/**
 * creates a MetaExtractor Object for a list, based on a sample
 * @param  {mo.List} _list sample list
 *
 * @param  {Object} resourceInformation object with complementary information
 * @return {schemaMetaExtractorTable} MetaExtractor Object for Table
 * tags:metaextractor,special,extract
 */
MetaExtractor.metaExtractorList = function(_list, resourceInformation){
	if(_list == null) return null;
	if(_list.metaExtractor!=null) return _list.metaExtractor;

	/**
	 * no SCHEMA for the time being
	 */
	//var mE =  mo.SchemaInstantiator.instantiate(mo.MetaExtractorSchemaForList); //<------ instantiation
	var mE = {
		objectType:"List",
		origin:{},
		data:{},
		information:{
			content:{}
		},
		meaning:{
			ontologyConcepts:{}
		}
	};

	_list.metaExtractor = mE;

	var infoObject = mo.ListOperators.buildInformationObjectForList(_list); //

    // This loop trough columns values is necessary as infoObject hasn't the information required.
    // TODO: enhance info Objects in order to avoid this unnecesarry loop
    //       and set a mostFrequentNotNullElement property and apply numeric calculation without considering the nulls when numeric
    var nullcount = 0, nonNullType, nonNullValues = new mo.NumberList();

	for(var j=0; j<_list.length; j++){

		//count the number of Nulls
        if(_list[j] == null) {
            nullcount++;
            continue;
        }

        //updated value on each iteration. this could be the type of the most frequent not null element instead of this;
        nonNullType = typeof _list[j];

        //get a subList with not null number elements
        if(typeof _list[j] === 'number') {
            nonNullValues.push(_list[j]);
        }
    }

    if(nonNullValues.length > 0) {
        infoObject.average = nonNullValues.getAverage();
        infoObject.standardDeviation = nonNullValues.getStandardDeviation();
    }

    mE.origin.type = 'Column';
    if(resourceInformation){
		mE.origin.source = resourceInformation.source;
	    mE.origin.hasDataBaseOrigin = resourceInformation.hasDataBaseOrigin;
		mE.origin.dataBaseDataType = resourceInformation.dataBaseColumnTypesDictionary[infoObject.name] || '';
	}

	/*================= DATA PROPERTIES =================*/
	mE.originId = MetaExtractor._getHashFromObject(mE.origin);

    mE.data.datatype = nonNullType;//Potential type
    mE.data.countRows = infoObject.length;

    mE.data.countRowsSimpleText = MetaExtractor._countRowsSimpleText(mE.data.countRows);


    /*================= INFORMATION PROPERTIES =================*/


    //many of these need to be calculated over list without nulls

	mE.simplifiedName = mo.StringOperators.cleanText(_list.name, true, true, null, true, true, false, true, true);
	mE.information.isCategorical = infoObject.isCategorical;
	mE.information.countDifferentElements = infoObject.numberDifferentElements;
	mE.information.uniqueValue = mE.information.countDifferentElements==1;
	mE.information.proportionDifferentElements = mE.information.countDifferentElements/infoObject.length;
	mE.information.allDifferent = mE.information.proportionDifferentElements > MetaExtractor.TOLERANCE_ALL_DIFFERENT;
	mE.information.allDifferentStrict = mE.information.proportionDifferentElements == 1;
	mE.information.entropy = infoObject.entropy;
	mE.information.countMostCommonElement = infoObject.frequenciesTable[1][0];
	mE.information.proportionMostCommonElement = infoObject.frequenciesTable[1][0]/infoObject.length;

	//mE.information.content = {};
	mE.information.content.containsNulls = infoObject.containsNulls;
	mE.information.content.countNulls = nullcount;
	mE.information.content.proportionNulls = nullcount / infoObject.length;
	mE.information.content.isSortedAscending = _list.isSorted(true);
	mE.information.content.isSortedDescending = _list.isSorted(false);
	mE.information.content.mostCommonElement = infoObject.mostFrequentElement;//content level 2
	mE.information.content.nullIsMostCommon = mE.information.content.mostCommonElement==null;
	mE.information.content.mostCommonElementNonNull = mE.information.content.nullIsMostCommon?infoObject.frequenciesTable[0][1]:mE.information.content.mostCommonElement;
	mE.information.informationScore = mo.ObjectOperators.getInformationScore(_list);

	MetaExtractor._kind_specificaton_potential_dimension(_list, mE);

	/*================= MEANING PROPERTIES =================*/
	var r = 0; //binary score reflecting if the column was revised or not by the wrangler, 0 being not revised, 1 being revised
	var sc = mE.specification.scoreConfidence;//score confidence calculated based on the first two best scores found for the column and the value of the maximum one
	var baseMeaningScore = 0.6 + Boolean(_list.label) * 0.1 + Boolean(_list.description) * 0.1;//BaseMScore: base meaning score: 0.6 + 0.1 if has label + 0.1 if has description
	var conditional = (1-r);// used as a if/else
	var meaningScore = conditional * (baseMeaningScore*sc) + r * (baseMeaningScore+0.2*sc)


    /*================= ROOT PROPERTIES =================*/
    mE.name = infoObject.name;
    mE.hash = MetaExtractor._getHashFromObject(JSON.stringify(mE));

	//Instantiate the DIM object holding the DIMScore total values
	mE.DIM = {
		D:{
			total: null /** value is given later within the Table extraction function whose this List belongs */
		},
		I:{
			total: mE.information.informationScore
		},
		M:{
			total: meaningScore
		}
	};
	return mE;
};

/**
 * kind, specification, potential and dimensiom, and every mE property that depends on List type
 * [!] This version doesn't modify the metaExtractor for the List!
 *
 * @param  {mo.List} list
 * @param  {MetaExtractorForList} mE
 */
MetaExtractor._kind_specificaton_potential_dimension = function(list, mE){
	var iO = mo.ListOperators.buildInformationObjectForList(list);
	var listWithoutNulls;

	var type = list.type;
	var kind = iO.kind;
	var potentialType;

	if(iO.containsNulls){
		listWithoutNulls = list.getWithoutElement();
		potentialType = listWithoutNulls.type;
	} else {
		listWithoutNulls = list;
		potentialType = type;
	}

	mE.type = type;
	mE.potentialType = potentialType;
	mE.potentialTyperealized = type==potentialType;


	//characters count, max, min, mean and standard deviation
	const listCountCharacters = listWithoutNulls.toStringList().getLengths();
	mE.information.content.minCountCharacters = listCountCharacters.getMin();
	mE.information.content.maxCountCharacters = listCountCharacters.getMax();
	mE.information.content.meanCountCharacters = listCountCharacters.getAverage();
	mE.information.content.stdCountCharacters = listCountCharacters.getStandardDeviation();
	mE.information.content.uniqueCountCharacters = mE.information.content.maxCountCharacters == mE.information.content.minCountCharacters;


	//specification functions for all lists

	var categoryScore = {
		name:"category",
		description:"short non-unique values",
		function:function(sL,mE){
			return mE.kind=="short" && !mE.information.isUnique?0.3:0;//imporve this with propoertion of different elements, maybe entropy
		},
		dimension:"classification",
		icons:[]
	};


	var scoresForAllLists = [categoryScore];
	var scoresByType;

	//specification functions for lists by type:
	switch(potentialType){
		case "NumberList":
			scoresByType = MetaExtractor._NumberList__specifications(listWithoutNulls,mE,scoresForAllLists);
			break;
		case "StringList":
			scoresByType = MetaExtractor._StringList__specifications(listWithoutNulls,mE,scoresForAllLists);
			break;
		default:
			scoresByType = MetaExtractor._List__specifications(listWithoutNulls,mE,scoresForAllLists);
			break;
	}

	mE.specification = MetaExtractor._buildSpecification(scoresForAllLists.concat(scoresByType),mE,listWithoutNulls);
};

MetaExtractor._stringMatchCalculation =  function(_checkList, _splittedName, maxScore){
		maxScore = maxScore || 1;
        var stringBestMatch = 1;
        _checkList.forEach(
			function(stringToAssess){

                //assess though all the splitted names values
                _splittedName.forEach(
                    function(_name){
                        //the third parameter make this function return a normalized value between 0 and 1
                        var attributeNameMatch = mo.StringOperators.getLevenshteinDistance(stringToAssess,_name, true);

                        stringBestMatch = (attributeNameMatch < stringBestMatch)? attributeNameMatch : stringBestMatch;

                    }
                );

            }
        );
        // subtract stringBestMatch from 1 in order to get 1 as the 100% of match.
        stringBestMatch = (1 - stringBestMatch);

        //Here we punich the value making it lower than it is, in order to be more stricts about this score.
		stringBestMatch = Math.pow(stringBestMatch,2)
		if(maxScore !== 1) maxScore * stringBestMatch;
        return stringBestMatch;
}

MetaExtractor._NumberList__specifications = function(list,mE,scoresForAllLists){
	var iO = mo.ListOperators.buildInformationObjectForList(list);

	mE.information.content.min = iO.min; //content level 2
	mE.information.content.max = iO.max; //content level 2
	mE.information.content.mean = iO.average;
	mE.information.content.standardDeviation = iO.standardDeviation;
	mE.information.content.sum = iO.sum;
	mE.information.content.amplitude = iO.max-iO.min;
	mE.information.content.allPositive = iO.allPositive;
	mE.information.content.allNegative = iO.allNegative;
	mE.information.content.allIntegers = iO.allIntegers;
	mE.information.content.normalizedUnit = mE.information.content.min>=0 && mE.information.content.max<=1;
	mE.information.content.containsOutliers = mo.NumberListOperators.getOutliers(list).length>0;
	mE.information.content.skewness = mo.NumberListOperators.skewness(list);

	mE.kind = (mE.information.content.allPositive && mE.information.content.allIntegers)?
		"natural numbers"
		:
		(
			mE.information.content.allPositive?
				"positive numbers"
				:
				(
					mE.information.content.allNegative?
						"negative numbers"
						:
						(
							mE.information.content.allIntegers?"integers":""
						)
				)
		);

	//specification

	var uniqueValue = iO.isUnique;

	var longScore = {
		name:"longitude geo coordinates",
		description:"verifies if list is longitude coordinates by name and range of values",
		function:function(list,mE){
			var inRange = mE.information.content.min>=-180 && mE.information.content.max<=180;
			var nameScore = mE.simplifiedName=="lng" || mE.simplifiedName=="lon" || mE.simplifiedName=="long" || mE.simplifiedName=="longitude"?1:0;
			if(nameScore==0 && mE.simplifiedName.indexOf("longitude")!=-1 ) nameScore=0.6;
			if(nameScore==0 && mE.simplifiedName.indexOf("long")!=-1 ) nameScore=0.35;
			var score = nameScore;
			if(!inRange) score*=0.1;
			return score*0.8;
		},
		dimension:"space",
		icons:[MetaExtractor.ICONS_WORLD]
	};
	var latScore = {
		name:"latitude geo coordinates",
		description:"verifies if list is latitude coordinates by name and range of values",
		function:function(list,mE){
			var inRange = mE.information.content.min>=-90 && mE.information.content.max<=90;
			var nameScore = mE.simplifiedName=="lat" || mE.simplifiedName=="latitude"?1:0;
			if(nameScore==0 && mE.simplifiedName.indexOf("latitude")!=-1 ) nameScore=0.6;
			if(nameScore==0 && mE.simplifiedName.indexOf("lat")!=-1 ) nameScore=0.35;
			var score = nameScore;
			if(!inRange) score*=0.1;
			return score*0.8;
		},
		dimension:"space",
		icons:[MetaExtractor.ICONS_WORLD]
	};

	var yearScore = {
		name:"year",
		description:"verifies if list describes years, by name and range of values",
		function:function(list,mE){
			var rangeScore = (mE.information.content.min>1900 && mE.information.content.max<=2020)?0.4:0;
			if(rangeScore==0 && mE.information.content.min>=1800 && mE.information.content.max<=2020) rangeScore = 0.2
			if(rangeScore==0 && mE.information.content.min>=2000 && mE.information.content.max<=3000) rangeScore = 0.1
			var nameScore = (["year","time","date"].includes(mE.simplifiedName))?0.4:0;
			if(nameScore==0 && mE.simplifiedName.indexOf("year ")==0) nameScore=0.3;
			if(nameScore==0 && mE.simplifiedName.indexOf("year")==0) nameScore=0.2;
			if(nameScore==0 && mE.simplifiedName.includes("year")) nameScore=0.1;
			return rangeScore + nameScore;
		},
		dimension:"time",
		icons:[MetaExtractor.ICONS_TIME]
	};

	var monetaryScore = {
		name:"monetary",
		description:"verifies if list describes monetary values, by name and range of values",
		function:function(list,mE){
			var rangeScore = (mE.information.content.min>=0)?0.2:0;
			var splittedName = mE.simplifiedName.split(/[\s_-]+/);

			/* ===== Name matching =======*/
			//Get a score for Attribute name matching, if the nameBestMatch is 0 means the attrbiute name had a 100% match.
        	var nameScore = MetaExtractor._stringMatchCalculation(
				["usd","money","revenue","profit","income","cash","price","value","margin","$","dollar"],
				splittedName
			);
			return rangeScore + nameScore*0.6;
		},
		dimension:"monetary",
		icons:[MetaExtractor.ICONS_MONEY]
	};

	//TBD:
	var ageScore = {
		name:"age",
		description:"verifies if list describes ages, by name and range of values",
		function:function(list,mE){
			var inRange = mE.information.content.min>=0 && mE.information.content.max<=100;
			var name = ["age"].includes(mE.simplifiedName);
			return (inRange && name)?0.8:0;
		},
		dimension:"demographic",
		icons:[MetaExtractor.ICONS_PERSON]
	};

	var demographicScore = {
		name:"demographic",
		description:"depends on the name of label, it's also the olisty score to be always >0, so it becomes default when all else fails",
		function:function(sL,mE){
			return MetaExtractor.DEOMGRAPHIC_NAMES.includes(mE.simplifiedName)?0.3:0.1;
		},
		dimension:"demographic",
		icons:[]
	};

	var cpfScore = {
		name:"cpf",
		description:"check contents using a regex for cpf type",
		regex:MetaExtractor.REGEX_CPF,
		likelyNames:["cpf"],
		dimension:"identification",
	};

	var ssnScore = {
		name:"ssn",
		description:"check contents using a regex for social security number type",
		regex:MetaExtractor.REGEX_SSN,
		likelyNames:["ssn","security"],
		dimension:"identification",
	};

	var idScore = {
		name:"id",
		description:"verifies whether it's natural numbers kind, all numbers equally long, and checks name",
		function:function(list,mE){
			var nameScore = mE.simplifiedName=="id"?0.4:0;
			if(nameScore==0) mE.simplifiedName.includes("id")?0.05:0;//TBD:improve this!
			var valuesScore = (uniqueValue && mE.kind == "natural numbers")?0.2:0;//TBD:check avergae char length, and sd char length
			var uniqueCountCharsScore = valuesScore*(mE.information.content.uniqueCountCharacters?0.2:0);
			return nameScore + valuesScore + uniqueCountCharsScore;
		},
		dimension:"identification",
		icons:[]
	};

	var countScore = {
		name:"count",
		description:"verifies whether it's natural numbers kind, and by name",
		function:function(list,mE){
			return (mE.kind == "natural numbers"?0.11:0) + ["count", "number", "counting"].includes(mE.simplifiedName)?0.3:0;
		},
		dimension:"count",
		icons:[]
	};

	//month number

	return [longScore, latScore, yearScore, cpfScore, ssnScore, idScore, countScore, ageScore, monetaryScore];
};

MetaExtractor._StringList__specifications = function(list,mE,scoresForAllLists){
	var iO = mo.ListOperators.buildInformationObjectForList(list);

	var lengths = list.getLengths(); //Get a list with the number of characters by each element on the string list
	var maxLength = lengths.getMax();
	var uniqueValue = iO.isUnique;

	//kind
	mE.kind = maxLength<=MetaExtractor.STRING_SHORT_LENGTH?"short":(maxLength<=MetaExtractor.STRING_MEDIUM_LENGTH?"medium":"long");

	//console.log("[mE] ", list.name, mE.kind);

	var monetaryScore = {
		name:"monetary",
		description:"verifies if list describes monetary values, by name",
		function:function(list,mE){
			var splittedName = mE.simplifiedName.split(/[\s_-]+/);

			/* ===== Name matching =======*/
			//Get a score for Attribute name matching, if the nameBestMatch is 0 means the attrbiute name had a 100% match.
        	var nameScore = MetaExtractor._stringMatchCalculation(
				["usd","money","revenue","profit","income","cash","price","value","margin","$","dollar"],
				splittedName,
				0.7 //<- limit the maximum score
			);

			return nameScore*0.6;
		},
		dimension:"monetary",
		icons:[MetaExtractor.ICONS_MONEY]
	};

	var dateScore = {
		name:"date",
		description:"",//check contents using a regex for typical date formats and, secondly, name of feature",
		//regex:MetaExtractor.REGEX_DATE,
		//likelyNames:["date","dates","time","times"],
		function:function(list,mE){
			var nDates = 0;
			var dt,num;
			//console.log("\n\n[mE] ",list.name, list.length);
			for(var i=0; i<list.length; i++){
				//console.log("   [mE] list[i], is date?", list[i], new Date(list[i])!="Invalid Date", !list[i].match(/^\s*[\-\>\=\<]/));
				dt = new Date(list[i]);
				num = Number(list[i]);
				if(!isNaN(dt) && isNaN(num) && !( num["match"] && num.match(/^\s*[\-\>\=\<]/)))
					nDates++;
				else if(Number.isInteger(num) && num >= 1000 && num <= 2300)
					nDates++;
				if(nDates<(i*0.5-20)) break;
			}

			var hasNameLabel = ["date","dates","time","times"].includes(mE.simplifiedName); //<-- here we should use label instead of name (?)
			var hasNameLabelScore = hasNameLabel?0.2:0;
			//console.log("[mE] nDates:", nDates);
			//console.log("[mE] score:", (nDates<3?0:(Math.pow(nDates/list.length, 0.2)))*0.7 + hasNameLabelScore);
			return (nDates<3?0:(Math.pow(nDates/list.length, 0.2)))*0.7 + hasNameLabelScore;
		},
		dimension:"time",
		icons:[MetaExtractor.ICONS_TIME]
	};

	var ssnScore = {
		name:"ssn",
		description:"check contents using a regex for social security number type",
		regex:MetaExtractor.REGEX_SSN,
		likelyNames:["ssn","security"],
		dimension:"identification",
	};

	var cpfScore = {
		name:"cpf",
		description:"check contents using a regex for cpf type",
		regex:MetaExtractor.REGEX_CPF,
		likelyNames:["cpf"],
		dimension:"identification",
	};

	var cityScore = {
		name:"city",
		description:"compare contents with a list of ~200 larger cities and, secondly, name of feature",
		function:function(list,mE){
			var matchesScore = MetaExtractor._listContentMatchScore(list, MetaExtractor.BIG_CITIES_NAMES, mE)*0.7;

			var hasCityLabel = MetaExtractor.LABELS_FOR_CITY_LIST.includes(mE.simplifiedName); //<-- here we should use label instead of name (?)
			var hasCityLabelScore = hasCityLabel?0.3:0;
			if(!hasCityLabelScore && mE.simplifiedName.includes("city")) hasCityLabelScore=0.15;

			return matchesScore + hasCityLabelScore;
		},
		dimension:"space",
		icons:[MetaExtractor.ICONS_CITY]
	};

	var USCityScore = {
		name:"US city",
		description:"compare contents with a list of US larger cities and, secondly, name of feature",
		function:function(list,mE){
			var matchesScore = MetaExtractor._listContentMatchScore(list, MetaExtractor.US_CITIES_NAMES, mE)*0.7;

			var hasCityLabel = MetaExtractor.LABELS_FOR_CITY_LIST.includes(mE.simplifiedName); //<-- here we should use label instead of name (?)
			var hasCityLabelScore = hasCityLabel?0.3:0;

			if(!hasCityLabelScore && mE.simplifiedName.includes("city")) hasCityLabelScore=0.15;
			return matchesScore + hasCityLabelScore;
		},
		dimension:"space",
		icons:[MetaExtractor.ICONS_CITY,MetaExtractor.ICONS_US]
	};

	var BrazilCityScore = {
		name:"Brazil city",
		description:"compare contents with a list of Brazil larger cities and, secondly, name of feature",
		function:function(list,mE){
			var matchesScore = MetaExtractor._listContentMatchScore(list, MetaExtractor.BRAZIL_CITIES_NAMES, mE)*0.7;

			var hasCityLabel = MetaExtractor.LABELS_FOR_CITY_LIST.concat(["cidade","cidades"]).includes(mE.simplifiedName); //<-- here we should use label instead of name (?)
			var hasCityLabelScore = hasCityLabel?0.3:0;
			if(!hasCityLabelScore && mE.simplifiedName.includes("city")) hasCityLabelScore=0.15;
			return matchesScore + hasCityLabelScore;
		},
		dimension:"space",
		icons:[MetaExtractor.ICONS_CITY,MetaExtractor.ICONS_Brazil]
	};

	var countryScore = {
		name:"country",
		description:"compare contents with a list of countries and, secondly, name of feature",
		function:function(list,mE){
			var matchesScore = MetaExtractor._listContentMatchScore(list, MetaExtractor.COUNTRIES_NAMES, mE)*0.7;
			//better to siolate match for ISO (2 or 3 letters) and full names, giving less weight to ISO

			var hasCountryLabel = ["country","cntry","region"].includes(mE.simplifiedName); //<-- here we should use label instead of name (?)
			var hasCountryLabelScore = hasCountryLabel?0.3:0;
			if(!hasCountryLabelScore && mE.simplifiedName.includes("country")) hasCountryLabelScore=0.15;
			return matchesScore + hasCountryLabelScore;
		},
		dimension:"space",
		icons:[MetaExtractor.ICONS_WORLD]
	};

	//NOTES
	//regex instead of function
	//   "double column" ---> /\s+[,|-]\s+/
	//   phone number ----> country
	//

	var usStateScore = {
		name:"US state",
		description:"compare contents with a list of Us states and, secondly, name of feature",
		function:function(list,mE){
			var matchesScore = MetaExtractor._listContentMatchScore(list, MetaExtractor.US_STATES_NAMES, mE)*0.7;

			var hasStateLabel = ["state","us state"].includes(mE.simplifiedName); //<-- here we should use label instead of name (?)
			var hasStateLabelScore = hasStateLabel?0.3:0;
			if(!hasStateLabelScore && mE.simplifiedName.includes("state")) hasStateLabelScore=0.15;
			return matchesScore + hasStateLabelScore;
		},
		dimension:"space",
		icons:[MetaExtractor.ICONS_US]
	};

	var personNameScore = {
		name:"person name",
		description:"uses regex, checks name of list, and checks wheter initial letter of words are capital",
		function:function(list,mE){
			//MetaExtractor.REGEX_PERSON_NAME
			var nNames = 0;
			for(var i=0; i<list.length; i++){
				if(list[i].length>30) continue;
				if(MetaExtractor.REGEX_PERSON_NAME.test(list[i].toLowerCase())){
					nNames+=0.3;
					if(list[i].indexOf(" ")>-1){
						nNames+=0.1;
						var parts = list[i].split(" ");
						if(parts.length>4) continue;
						for(var j=0;j<parts.length; j++){
							if(parts[j].substr(0,1)!=parts[j].substr(0,1).toLowerCase() && parts[j].substr(0,1)==parts[j].substr(0,1).toLowerCase()) nNames+=parts.length;
						}
					}
				}
			}

			var hasNameLabel = ["name","person","individual"].includes(mE.simplifiedName); //<-- here we should use label instead of name (?)
			var hasNameLabelScore = hasNameLabel?0.2:0;
			return (nNames<3?0:(Math.pow(nNames/list.length, 0.2)))*0.7 + hasNameLabelScore;
		},
		dimension:"identification",
		icons:[MetaExtractor.ICONS_PERSON]
	};

	var idScore = {
		name:"id",
		description:"a short unique text is identified as probable id",
		function:function(list,mE){
			return mE.kind=="short" && (mE.information.proportionDifferentElements>0.9)?0.5:0;
		},
		dimension:"identification"
	};

	var descriptionScore = {
		name:"description",
		description:"a long unique text is probably a description of sorts",
		function:function(list,mE){
			return (mE.kind=="long"?0.4:0)*mE.information.proportionDifferentElements + (["description","text","summary"].includes(mE.simplifiedName)?0.3:0);
		},
		dimension:"identification",
		icons:[MetaExtractor.ICONS_TEXT]
	};

	var demographicScore = {
		name:"demographic",
		description:"depends on the name of label, it's also the only score to be always >0, so it becomes default when all else fails",
		function:function(list,mE){
			return MetaExtractor.DEOMGRAPHIC_NAMES.includes(mE.simplifiedName)?0.3:0.1;
		},
		dimension:"demographic",
		icons:[]
	};

	var emailScore = {
		name:"email",
		description:"email format xxxxx@xxxxxx.xxx (based on regex)",
		regex:MetaExtractor.REGEX_EMAIL,
		likelyNames:["mail","email","address","email address"],
		dimension:"identification",
		icons:[MetaExtractor.ICONS_EMAIL]

	};

	var urlScore = {
		name:"url",
		description:"url format, based on regex",
		regex:MetaExtractor.REGEX_URL,
		likelyNames:["url","link","address","web","site","website","urls","links","addresses","webs","sites","websites"],
		dimension:"external resource",
		icons:[MetaExtractor.ICONS_LINK]
	};

	var urlFileScore = {
		name:"url file",
		description:"url format based on regex, and presence of .csv, .txt",
		regex:MetaExtractor.REGEX_URL_FILE,
		likelyNames:["file","csv","download"],
		dimension:"external resource",
		icons:[MetaExtractor.ICONS_LINK]
	};

	var urlImageScore = {
		name:"url image",
		description:"url format based on regex, and presence of .jpeg, .jpg or .png",
		regex:MetaExtractor.REGEX_URL_IMAGE,
		likelyNames:["url","image","images","pic","picture","pics","pictures"],
		dimension:"external resource",
		icons:[MetaExtractor.ICONS_LINK,MetaExtractor.ICONS_IMAGE]
	};

	/*zip codes*/

	return [dateScore, cityScore, USCityScore, BrazilCityScore, countryScore, usStateScore, idScore, ssnScore, cpfScore, descriptionScore, demographicScore, personNameScore, emailScore, urlImageScore, urlScore, urlFileScore, monetaryScore];
};

MetaExtractor._List__specifications = function(list,mE,scoresForAllLists){
	mE.mixedTypes = true;
	mE.specification = {};
	var types = new mo.StringList();
	for(var i=0;i<list.length;i++){
		types[i] = MetaExtractor._typeOf(list[i]);
	}
	mE.elementsTypes = types.getWithoutRepetitions();

	var monetaryScore = {
		name:"monetary",
		description:"verifies if list describes monetary values, by name",
		function:function(list,mE){
			var splittedName = mE.simplifiedName.split(/[\s_-]+/);

			/* ===== Name matching =======*/
			//Get a score for Attribute name matching, if the nameBestMatch is 0 means the attrbiute name had a 100% match.
        	var nameScore = MetaExtractor._stringMatchCalculation(
				["usd","money","revenue","profit","income","cash","price","value","margin","$","dollar"],
				splittedName,
				0.5 //<- limit the maximum score
			);

			return nameScore*0.6;
		},
		dimension:"monetary",
		icons:[MetaExtractor.ICONS_MONEY]
	};


	return [monetaryScore];
};




MetaExtractor._buildSpecification = function(scoreObjects,mE,list){
	var scores = [];
	var maxScore = 0;
	var secondScore = -1;
	var secondSpecification;
	var maxScoreName="";
	var maxScoreDescription;
	var scoreConfidence; //score * (distance between highest and second score) 0: ambiguity and/or low scores, 1:total certainty
	var icons;

	var samplelist = list.getRandomElements(200,false,Number(list.name));

	var _regexScore = function(regex, likelyNames){
		var valid = 0;
		for(var i=0; i<samplelist.length; i++){
			valid += Number(regex.test(String(samplelist[i])));
		}
		return (valid/samplelist.length)*0.8 + likelyNames.includes(mE.simplifiedName)*0.1;
	};

	//console.log("[mE] scores ----------");

	for(var i=0;i<scoreObjects.length; i++){

		if(scoreObjects[i].function){
			scores[i] = scoreObjects[i].function.call(this,samplelist,mE);
		} else {
			scores[i] = _regexScore(scoreObjects[i].regex, scoreObjects[i].likelyNames);
		}

		//console.log("   [mE] ",scoreObjects[i].name,"->",scores[i]);

		if(scores[i]>maxScore){
			if(maxScore>secondScore){
				secondScore=maxScore;
				secondSpecification = maxScoreName;
			}
			maxScore = scores[i];
			maxScoreName = scoreObjects[i].name;
			maxScoreDescription = scoreObjects[i].description;
			mE.dimension = scoreObjects[i].dimension;
			icons = scoreObjects[i].icons;
		} else if(scores[i]>=secondScore){
			secondScore = scores[i];
			secondSpecification = scoreObjects[i].name;
		}

		//console.log(scoreObjects[i].dimension+","+scoreObjects[i].name+",["+scoreObjects[i].icons+"]");
	}

	scoreConfidence = maxScore*( 0.2*(maxScore-secondScore) + 0.8);

	var specification = {
		name:maxScoreName
	};

	specification.maxScore = maxScore;
	specification.secondScore = secondScore;
	specification.secondSpecification = secondScore>0?secondSpecification:"";
	specification.scoreConfidence = scoreConfidence;
	specification.description = maxScoreDescription;
	specification.icons = icons||[];

	specification.baseName = specification.name;
	specification.name = (mE.information.allDifferent?"unique ":"")+specification.name;
	specification.name = (mE.information.countDifferentElements==1?"single ":"")+specification.name;
	specification.name = (mE.information.countDifferentElements==2?"binary ":"")+specification.name;

	return specification;
};

/**
 * counts number of content matches, and different content matches
 * @param  {mo.List} list
 * @param  {mo.List} baseList such as a list of US cities
 * @param {Object} mE metaExtractor
 * @return {Object} Object with nMatches and nMatches
 */
MetaExtractor._listContentMatchScore = function(list, baseList, mE){
	var nMatches = 0;
	var nMatchesDifferent = 0;

	for(var i=0; i<list.length; i++){
		if(baseList.includes(list[i].toLowerCase())){
			nMatches++;
		}
	}

	var listWR = list.getWithoutRepetitions();
	for(i=0; i<listWR.length; i++){
		if(baseList.includes(listWR[i].toLowerCase())){
			nMatchesDifferent++;
		}
	}

	return (nMatches<3?0:(Math.pow(nMatches/list.length, 0.2)))*0.6  + (nMatchesDifferent/mE.information.countDifferentElements)*0.4;
};

/**
 * Returns the type of an object. Can be recursive when the type is an Array
 * @param {Object} object
 * @return {String}
 */
MetaExtractor._recursiveTypeOf = function(object) {
	if(object==null) return null;

	var type = typeof object;
	if(type !== 'object') return type;

	if(object.type!=null) return object.type;

	if(Object.prototype.toString.call(object) == "[object Array]") return "Array>"+MetaExtractor._recursiveTypeOf(object[0]);//return "Array";

	if(object.getDate != null) return 'date';

	return 'Object';
};

/**
 * identical to typeOf at ClassUtils
 * @param {Object} object
 * @return {String}
 */
MetaExtractor._typeOf = function(object) {
  if(object==null) return null;

  var type = typeof object;
  if(type !== 'object') return type;

  if(object.type!=null) return object.type;

  if(Object.prototype.toString.call(object) == "[object Array]") return "Array";

  if(object.getDate != null) return 'date';

  return 'Object';
};



/**
 * creates a MetaExtractor Object for a list, based on a sample
 * @param  {String} _string short or long text
 *
 * @param  {Object} resourceInformation object with complementary information
 * @return {schemaMetaExtractorTable} MetaExtractor Object for Table
 * tags:metaextractor,special,extract
 */
MetaExtractor.metaExtractorString = function(_string, resourceInformation){
	if(_string==null) return null;

	resourceInformation = resourceInformation || {};

	var id = _string.substr(0,500).replace(/\s|\.|\,|:/g,"");//to be improved //use a hash?//<---use some other method! (hash, combination of first part and hash…)

	var mE = {
		objectType:"string",
		id:id,
		name:_string.substr(0,20)+"…",
		information:{},
		data:{},
		meaning:{},
		relations:[],
		attributes:[],
		user: resourceInformation._user || "noUserInformation",
        organization: resourceInformation._organization || "noOrganizationInformation"
	};

	mE.information.length = _string.length;

	var words = mo.StringOperators.getWords(_string, false);
	var wordsWithoutRepetitions = words.getWithoutRepetitions();

	//identify language
	//words minus stopwords
	//most requent word
	//word average length
	//count paragraphs
	//count enters
	//count double-spaces
	//count diacritics
	//special formats (csv,xml,json, structure…)
	//candidate separators (" ", ".", ENTER, DOUBLE-ENTER "*", "chapter", "-" / separator and number of texts)

	//var mEWords = MetaExtractor.metaExtractorList(words);

	mE.information.countWords = words.length;
	mE.information.countDifferentWords = wordsWithoutRepetitions.length;
	mE.information.countPages = Math.ceil(mE.information.countWords/500);
	mE.information.countEnters = _string.split(/\n/g).length-1;


	mE.information.separators = [];
	//…identify separators

	mE.views = [];
	mE.views.push("documenta");

	////////////score

	//first version relies in scoreReportObject
	//next version will calculate score based on lists' score, diversity of types in table, and relations within lists
	//var scoreReportObject = TableOperators.scoreReportObject(table);

	//how to convert a text into a table so DIM for tables applies here?
	//a table with a list of sentences?
	//a table with a list of words?
	//a table with one list of sentences and one list of words?
	//the above + list of "special" words?

	mE.information.DIMscore = {
		score:Math.log(mE.information.countDifferentWords)
	};
	mE.data.DIMscore = {
		score:Math.log(mE.information.countWords)//equivalent to number of cells
	};
	mE.meaning.DIMscore = {
		score:1//equivalent to number of cells
	};

	mE.dim = mE.information.DIMscore.score*mE.data.DIMscore.score*mE.meaning.DIMscore.score;

	return mE;
};



/**
 * Function aimed to split and flatten the MetaExtractor Object into 3 parts, for Origin, Table and Columns information
 * @param {Object} mE MetaExtractor object
 *
 * @return {Object} OriginInfo
 * @return {Object} TableInfo
 * @return {List} ColumnsInfo
 * tags:metaextractor,special
 */
MetaExtractor.splitAndFlattenMetaExtractor = function(mE) {
		if(mE == null) return null;
		var input = JSON.parse(JSON.stringify(mE));
    const columns = input.attributes
    delete input.attributes
    const origin = input.origin
    origin.id = input.originId
    delete input.origin
    const table = input
    table.originId = origin.id
    delete table.originId

    var flattenObject = function (ob) {
        var toReturn = {};

        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;

            if ((typeof ob[i]) == 'object') {
                var flatObject = flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;

                    toReturn[i + '_' + x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    };

    const flatColumns = mo.List.fromArray(
		columns.map(col => {
			delete col.data.origin
			delete col.data.originId

			return flattenObject(col)
		})
	);

    const result = [flattenObject(origin), flattenObject(table), flatColumns]

    return [
		{
			type: "Object",
			name: "OriginInformation",
			description: "Object holding information about Origin",
			value: result[0]
		},
		{
			type: "Object",
			name: "TableInformation",
			description: "Object holding information about Table",
			value: result[1]
		},
		{
			type: "List",
			name: "ColumnsInformation",
			description: "Object holding information about Columns",
			value: result[2]
		}
	]
}


/**
 * Function to extract the table table
 * @param {Object} metraExtraction
 * @param {Object} resourceInfoObject
 * @param {Object} resourceInformation
 */
MetaExtractor._tablePropertiesExtraction = function(mE, resourceInfoObject, resourceInformation, anIdentifierColumnHasBeenFound ){

    /*================= DATA PROPERTIES =================*/
    mE.data.countSampleRows = resourceInfoObject.averageLength;
    mE.data.countRows = resourceInformation.populationDatapoints || mE.data.countSampleRows;
    mE.data.frequency = 1;//Info preenchida por usuario
    mE.data.nAttributes = resourceInfoObject.length;
    mE.data.countRowsSimpleText = MetaExtractor._countRowsSimpleText(mE.data.countRows);
	mE.data.dataScore = Math.log10(mE.data.countRows+1) * Math.log10(mE.data.nAttributes+1); //later add frequency to it.
	//mE.data.dataScore = Math.log10(mE.data.countRows * mE.data.nAttributes); //later add frequency to it.

	//console.log("[mE] mE.data.countRows, mE.data.nAttributes, mE.data.dataScore", mE.data.countRows, mE.data.nAttributes, mE.data.dataScore);

    // ORIGIN  PROPERTIES
    mE.origin.type = 'Table';
	mE.origin.source = resourceInformation.source;
	mE.origin.hasDataBaseOrigin = resourceInformation.hasDataBaseOrigin;
	mE.originId = MetaExtractor._getHashFromObject(mE.origin);

    /*================= MEANING PROPERTIES =================*/
	mE.meaning.label = resourceInformation.label;
	if(mE.origin.hasDataBaseOrigin )
	mE.meaning.description = resourceInformation.description;
	if(anIdentifierColumnHasBeenFound) {
		mE.meaning.ontologyConcepts.DWResourceType = "Entity";
	} else {
		// A table with no Identifier couldn't be an Entity and therefore have no DWEntityType
		delete mE.meaning.ontologyConcepts.DWEntityType;
	}

    /*================= ROOT PROPERTIES =================*/
    mE.name = resourceInformation.name;
    mE.user = resourceInformation.user;
    mE.organization = resourceInformation.organization;
	//TODO improve this property to include the whole extractor but the ID
	mE.id = resourceInformation.datasetId;
	mE.dataSourceId = resourceInformation.dataSourceId;
	mE.dataSourceName = resourceInformation.dataSourceName;
	mE.hash = MetaExtractor._getHashFromObject(mE.organization + mE.name + JSON.stringify(mE.data) );

}

/**
 * transforms a metaExtracor, adds score values
 * @param  {schemaMetaExtractorTable} metaExtractor to be transformed
 *
 */
MetaExtractor._addScoreToMetaExtractor = function(resourceMetaExtractor, _informationObject){
	/*================= DATA PROPERTIES =================*/
	resourceMetaExtractor.data.score = Math.log(resourceMetaExtractor.data.nAttributes) *
		Math.log(resourceMetaExtractor.data.samplingDataPoints) *
		resourceMetaExtractor.data.frequency;

	/*================= INFORMATION PROPERTIES =================*/
	var _qualityReport = _informationObject.dataQualityReport;
	resourceMetaExtractor.information.score = _qualityReport.dataQuality/_qualityReport.sizeScore;

	/*================= MEANING PROPERTIES =================*/
	resourceMetaExtractor.meaning.score = 1;

	/*================= TOTAL =================*/
	resourceMetaExtractor.score = resourceMetaExtractor.data.score *
		resourceMetaExtractor.information.score *
		resourceMetaExtractor.meaning.score;

};


/**
 * creates a Network that expresses relations from a metaExtractor for TableList
 * @param  {Object} mETL metaExtractorObjectList
 *
 * @param  {Boolean} list_list_within builds relations within lists of same table (default:true)
 * @param  {Boolean} list_list_across builds relations of lists across tables (default:true)
 * @param  {Boolean} table_list builds relations between tables and their lists (default:true)
 * @param  {Boolean} table_table builds relations between tables (default:true)
 * @param  {StringList} relationsTypes optional list of types of relations for building the network (Pearson Correlation, Jaccard, Information Gain…)
 * @param {Number} relationsThreshold relation threshold
 * @return {mo.Network}
 * tags:metaextractor,special,network
 */
MetaExtractor.buildMetaExtractorNetwork = function(mETL, list_list_within, list_list_across, table_list, table_table, relationsTypes, relationsThreshold) {
    if(mETL == null) return null;
    list_list_within = list_list_within==null?true:list_list_within;
    list_list_across = list_list_across==null?true:list_list_across;
    table_list = table_list==null?true:table_list;
    table_table = table_table==null?true:table_table;

    relationsThreshold = relationsThreshold || 0;

    var attributes = mETL.attributes;
    var attributesT, attributesL;
    var net = new mo.Network();
    var node,node1,relation;
    var id, node0_id, node1_id;
    var color;

    var _buildNode = function(mE, ontoType, node_class, color,metaExtractor){
		var node = new mo.Node(mE.id, mE.name);
        node.ontoType = ontoType;
        node.class = node_class;
        node.color = color;
        node.metaExtractor = mE;
        net.addNode(node);
        return node;
    };

    var _buildOrExpandRelation = function(node0_id, node1_id, weight, ontoType, relation_class, color, relationObject){
        var node0 = net.nodeList.getNodeById(node0_id);
        var node1 = net.nodeList.getNodeById(node1_id);
        if(node0==null || node1==null) return;

        var _minId = function(id0, id1){
        	return id0<id1?id0:id1;
        };
        var _maxId = function(id0, id1){
        	return id0>=id1?id0:id1;
        };
        var id =  relationObject.directional?node0.id+"→"+node1.id:_minId(node0.id,node1.id)+"↔"+_maxId(node1.id, node0.id);
        var relation = net.relationList.getNodeById(id);


        var relationWeight = weight-relationObject.threshold;

        var simplifiedRelationObject = {
    		name:relationObject.name,
    		color:relationObject.color,
    		directional:relationObject.directional,
    		threshold:relationObject.threshold,
    		directional:relationObject.directional,
    		weight:relationWeight
    	}

        if(relation!=null){
        	relation.name+= " | " + relationObject.name;
        	relation.weight+=relationWeight;
        	relation.originalWeight += weight;
        	relation.color = mo.ColorOperators.interpolateColors(color, relation.color, 1/(relation.weights.length+1) );
        	relation.weights.push(relationWeight);
        	relation.originalWeights.push(weight);
        	relation.relationObject = null;
      		relation.relationObjects.push(simplifiedRelationObject);
      		relation.label = relation.name+" "+relation.originalWeight;

        	return relation;
        }

        relation = new mo.Relation(id, relationObject.name, node0, node1, relationWeight);
        relation.ontoType = ontoType;
        relation.class = relation_class;
        relation.color = color;
        relation.nodesOntoTypes = node0.ontoType+"_"+node1.ontoType;
        relation.relationObject = relationObject;
        relation.relationObjects = new mo.List();
        relation.relationObjects[0] = simplifiedRelationObject;
        relation.originalWeight = weight;
        relation.weights = new mo.NumberList();
        relation.weights[0] = relation.weight;
        relation.originalWeights = new mo.NumberList();
        relation.originalWeights[0] = relation.originalWeight;
        relation.directional = simplifiedRelationObject.directional;
        net.addRelation(relation);
        relation.label = relation.name+" "+relation.originalWeight;
        return relation;
    };

     //build nodes
    for(var i=0;i<attributes.length;i++){
    	var type = attributes[i].objectType;// MetaExtractor._typeOf(attributes[i]);

        //table or object
		node = _buildNode(attributes[i], "entity", type, 'rgb(100,100,100)');

		if(type=="Table"){
			attributesT = attributes[i].attributes;
	        //list
	        for(var j=0; j<attributesT.length; j++){
	        	//TODO: criteria for color for table nodes
				//node = _buildNode(attributesT[j], "entity", "List", 'rgb(200,200,200)');
				//console.log(attributesT[j].name, attributesT[j].potentialType, "-c->", mo.getColorFromDataModelType(attributesT[j].potentialType));
				node = _buildNode(attributesT[j], "entity", "List", mo.getColorFromDataModelType(attributesT[j].potentialType) );
				node.weight = attributesT[j].information.informationScore;
				node.tableName = attributes[i].name;
	        }
	    }
    }


	var tablesDictionary = {};
	var indexDictionary = {};
	var tablesIdDictionary = {};
	var columnsIdDictionaty = {};
	for(i=0;i<attributes.length;i++){
		tablesDictionary["table_"+i] = attributes[i];
		indexDictionary["table_"+i] = i;
		tablesIdDictionary[attributes[i].id] = attributes[i];
		for(j=0;j<attributes[i].attributes.length;j++){
			columnsIdDictionaty[attributes[i].attributes[j].id] = attributes[i].attributes[j];
		}
	}

    //inner relations
    var relObject, relationArray;
    for(var i=0;i<attributes.length;i++){
    	var type = attributes[i].objectType;// MetaExtractor._typeOf(attributes[i]);
    	if(type=="Table"){
	        attributesT = attributes[i].attributes;

	        //table to list
	        if(table_list){
	            node0_id =  attributes[i].id;//"table_"+i;
	            for(j=0;j<attributesT.length;j++){
	                //node1 = net.nodeList.getNodeById(i+"_"+attributesT[j].name);
	                node1_id =  attributesT[j].id;//i+"_"+attributesT[j].name;
	                _buildOrExpandRelation(node0_id, node1_id, 1, "entities", "table_to_list", 'rgb(200,200,200)', {});
	            }
	        }
	    }

	    var weight;

        //list to list
        if(list_list_within){
            for(j=0; j<attributes[i].relations.length; j++){
                relObject = attributes[i].relations[j];
                if(relationsTypes!=null && !relationsTypes.includes(relObject.name)) continue;
                color = mo.ColorOperators.interpolateColors( relObject.color, 'white', 0.8);
                for(var k=0;k<relObject.relations.length; k++){
                    relationArray = relObject.relations[k];
                    node0_id = columnsIdDictionaty[relationArray[2]].id;//i+"_"+attributesT[relationArray[2]].name;
                    node1_id = columnsIdDictionaty[relationArray[3]].id;//i+"_"+attributesT[relationArray[3]].name;
                    weight = Math.abs(relationArray[4]);
                    if(weight-relObject.threshold>relationsThreshold) _buildOrExpandRelation(node0_id, node1_id, weight, "entities", "list_to_list_within", relObject.color, relObject);
                }
            }
        }
    }


    var tablesDictionary = {};
    var indexDictionary = {};
    for(i=0;i<attributes.length;i++){
        tablesDictionary["table_"+i] = attributes[i];
        indexDictionary["table_"+i] = i;
    }


    //accross tables
    var accrossR = mETL.relations;
    var attributesT0, attributesT1;
    var idTable0, idTable1;
    var relationArray, list0name, list1name;
    var relationListsWeight;
    for(i=0;i<accrossR.length;i++){
        relObject = accrossR[i];
        if(relationsTypes!=null && !relationsTypes.includes(relObject.name)) continue;
        color = mo.ColorOperators.interpolateColors( relObject.color, 'black', 0.6 );
        for(j=0;j<relObject.relations.length;j++){
            relationArray = relObject.relations[j];
            attributesT0 = tablesIdDictionary[relationArray[0]];//tablesDictionary[relationArray[0]].attributes;
            attributesT1 = tablesIdDictionary[relationArray[1]];//tablesDictionary[relationArray[1]].attributes;

            list0name = columnsIdDictionaty[relationArray[2]].name;// attributesT0[relationArray[2]].name;
            list1name = columnsIdDictionaty[relationArray[3]].name;// attributesT1[relationArray[3]].name;

            relationListsWeight = Math.abs(relationArray[4]);

            idTable0 = attributesT0.id;//iindexDictionary[relationArray[0]];
            idTable1 = attributesT1.id;//iindexDictionary[relationArray[1]];

            //between tables (creates or adds weight to existing)
            if(table_table){
                node0_id = idTable0;//"table_"+idTable0;
                node1_id = idTable1;//"table_"+idTable1;
                relation = _buildOrExpandRelation(node0_id, node1_id, relationListsWeight, "entities", "table_to_table", 'gray', relObject);
                var containsJaccard = relObject.name=="Jaccard";
                if(containsJaccard) relation.color = 'rgb(150,200,150';
            }

            //between lists
            if(list_list_across){
                node0_id = columnsIdDictionaty[relationArray[2]].id;//idTable0+"_"+list0name;
                node1_id = columnsIdDictionaty[relationArray[3]].id;//idTable1+"_"+list1name;
                if(relationListsWeight-relObject.threshold>relationsThreshold) _buildOrExpandRelation(node0_id, node1_id, relationListsWeight, "entities", "list_to_list_across", color, relObject);
            }
        }
    }

    return net;
}


/**
 * Function used to extract a hash number to represent Object content
 * TODO: Improve this functino to aaply a better technique
 * @param {*} obj
 */
MetaExtractor._getHashFromObject = function(obj){
    var _obj;
    if(typeof obj === 'object')
        _obj = JSON.stringify(obj);
    else
        _obj = obj;

    var hash = 0;
    try{
    	hash = Buffer.from(_obj).toString('base64'); //method encodes a string in base-64.
    } catch(e){
		const isBrowser = new Function('try { return this === window } catch (error) { return false }');

		try{
			hash = isBrowser() ? btoa(_obj) : "hash failed / non-latin characters";
		} catch(err){
			hash = "#--";
		}
    }


    return hash.replace(/\=/g,'');
};


MetaExtractor._countRowsSimpleText = function(n){
		var log10int = Math.floor(Math.log(n)/Math.log(10));
	    if(log10int<3){
	    	return n;
	    } else if(log10int<6){
	    	return Math.floor(n/1000)+"K";
	    } else if(log10int<9){
	    	return Math.floor(n/1000000)+"M";
	    } else if(log10int<12){
	    	return Math.floor(n/1000000000)+"G";
	    }
	    return "BIG!";
    }


//#>